import { createIcon } from '../../icon';

import CopyXSmallIconSvg from './copy-xsmall.svg';
import CopyXSmallBoldIconSvg from './copy-xsmall-bold.svg';
import CopySmallIconSvg from './copy-small.svg';
import CopySmallBoldIconSvg from './copy-small-bold.svg';
import CopyMediumIconSvg from './copy-medium.svg';
import CopyMediumBoldIconSvg from './copy-medium-bold.svg';
import CopyLargeIconSvg from './copy-large.svg';
import CopyLargeBoldIconSvg from './copy-large-bold.svg';
import ChevronDownXSmallIconSvg from './chevron-down-xsmall.svg';
import ChevronDownXSmallBoldIconSvg from './chevron-down-xsmall-bold.svg';
import ChevronDownSmallIconSvg from './chevron-down-small.svg';
import ChevronDownSmallBoldIconSvg from './chevron-down-small-bold.svg';
import ChevronDownMediumIconSvg from './chevron-down-medium.svg';
import ChevronDownMediumBoldIconSvg from './chevron-down-medium-bold.svg';
import ChevronDownLargeIconSvg from './chevron-down-large.svg';
import ChevronDownLargeBoldIconSvg from './chevron-down-large-bold.svg';
import EyeOffXSmallIconSvg from './eye-off-xsmall.svg';
import EyeOffXSmallBoldIconSvg from './eye-off-xsmall-bold.svg';
import EyeOffSmallIconSvg from './eye-off-small.svg';
import EyeOffSmallBoldIconSvg from './eye-off-small-bold.svg';
import EyeOffMediumIconSvg from './eye-off-medium.svg';
import EyeOffMediumBoldIconSvg from './eye-off-medium-bold.svg';
import EyeOffLargeIconSvg from './eye-off-large.svg';
import EyeOffLargeBoldIconSvg from './eye-off-large-bold.svg';
import Trash01XSmallIconSvg from './trash01-xsmall.svg';
import Trash01XSmallBoldIconSvg from './trash01-xsmall-bold.svg';
import Trash01SmallIconSvg from './trash01-small.svg';
import Trash01SmallBoldIconSvg from './trash01-small-bold.svg';
import Trash01MediumIconSvg from './trash01-medium.svg';
import Trash01MediumBoldIconSvg from './trash01-medium-bold.svg';
import Trash01LargeIconSvg from './trash01-large.svg';
import Trash01LargeBoldIconSvg from './trash01-large-bold.svg';
import SearchXSmallIconSvg from './search-xsmall.svg';
import SearchXSmallBoldIconSvg from './search-xsmall-bold.svg';
import SearchSmallIconSvg from './search-small.svg';
import SearchSmallBoldIconSvg from './search-small-bold.svg';
import SearchMediumIconSvg from './search-medium.svg';
import SearchMediumBoldIconSvg from './search-medium-bold.svg';
import SearchLargeIconSvg from './search-large.svg';
import SearchLargeBoldIconSvg from './search-large-bold.svg';
import PlusXSmallIconSvg from './plus-xsmall.svg';
import PlusXSmallBoldIconSvg from './plus-xsmall-bold.svg';
import PlusSmallIconSvg from './plus-small.svg';
import PlusSmallBoldIconSvg from './plus-small-bold.svg';
import PlusMediumIconSvg from './plus-medium.svg';
import PlusMediumBoldIconSvg from './plus-medium-bold.svg';
import PlusLargeIconSvg from './plus-large.svg';
import PlusLargeBoldIconSvg from './plus-large-bold.svg';
import MinusXSmallIconSvg from './minus-xsmall.svg';
import MinusXSmallBoldIconSvg from './minus-xsmall-bold.svg';
import MinusSmallIconSvg from './minus-small.svg';
import MinusSmallBoldIconSvg from './minus-small-bold.svg';
import MinusMediumIconSvg from './minus-medium.svg';
import MinusMediumBoldIconSvg from './minus-medium-bold.svg';
import MinusLargeIconSvg from './minus-large.svg';
import MinusLargeBoldIconSvg from './minus-large-bold.svg';
import Menu01XSmallIconSvg from './menu01-xsmall.svg';
import Menu01XSmallBoldIconSvg from './menu01-xsmall-bold.svg';
import Menu01SmallIconSvg from './menu01-small.svg';
import Menu01SmallBoldIconSvg from './menu01-small-bold.svg';
import Menu01MediumIconSvg from './menu01-medium.svg';
import Menu01MediumBoldIconSvg from './menu01-medium-bold.svg';
import Menu01LargeIconSvg from './menu01-large.svg';
import Menu01LargeBoldIconSvg from './menu01-large-bold.svg';
import Settings01XSmallIconSvg from './settings01-xsmall.svg';
import Settings01XSmallBoldIconSvg from './settings01-xsmall-bold.svg';
import Settings01SmallIconSvg from './settings01-small.svg';
import Settings01SmallBoldIconSvg from './settings01-small-bold.svg';
import Settings01MediumIconSvg from './settings01-medium.svg';
import Settings01MediumBoldIconSvg from './settings01-medium-bold.svg';
import Settings01LargeIconSvg from './settings01-large.svg';
import Settings01LargeBoldIconSvg from './settings01-large-bold.svg';
import Target03XSmallIconSvg from './target03-xsmall.svg';
import Target03XSmallBoldIconSvg from './target03-xsmall-bold.svg';
import Target03SmallIconSvg from './target03-small.svg';
import Target03SmallBoldIconSvg from './target03-small-bold.svg';
import Target03MediumIconSvg from './target03-medium.svg';
import Target03MediumBoldIconSvg from './target03-medium-bold.svg';
import Target03LargeIconSvg from './target03-large.svg';
import Target03LargeBoldIconSvg from './target03-large-bold.svg';
import Star01XSmallIconSvg from './star01-xsmall.svg';
import Star01XSmallBoldIconSvg from './star01-xsmall-bold.svg';
import Star01SmallIconSvg from './star01-small.svg';
import Star01SmallBoldIconSvg from './star01-small-bold.svg';
import Star01MediumIconSvg from './star01-medium.svg';
import Star01MediumBoldIconSvg from './star01-medium-bold.svg';
import Star01LargeIconSvg from './star01-large.svg';
import Star01LargeBoldIconSvg from './star01-large-bold.svg';
import StarFilledXSmallIconSvg from './star-filled-xsmall.svg';
import StarFilledXSmallBoldIconSvg from './star-filled-xsmall-bold.svg';
import StarFilledSmallIconSvg from './star-filled-small.svg';
import StarFilledSmallBoldIconSvg from './star-filled-small-bold.svg';
import StarFilledMediumIconSvg from './star-filled-medium.svg';
import StarFilledMediumBoldIconSvg from './star-filled-medium-bold.svg';
import StarFilledLargeIconSvg from './star-filled-large.svg';
import StarFilledLargeBoldIconSvg from './star-filled-large-bold.svg';
import Edit05XSmallIconSvg from './edit05-xsmall.svg';
import Edit05XSmallBoldIconSvg from './edit05-xsmall-bold.svg';
import Edit05SmallIconSvg from './edit05-small.svg';
import Edit05SmallBoldIconSvg from './edit05-small-bold.svg';
import Edit05MediumIconSvg from './edit05-medium.svg';
import Edit05MediumBoldIconSvg from './edit05-medium-bold.svg';
import Edit05LargeIconSvg from './edit05-large.svg';
import Edit05LargeBoldIconSvg from './edit05-large-bold.svg';
import EyeXSmallIconSvg from './eye-xsmall.svg';
import EyeXSmallBoldIconSvg from './eye-xsmall-bold.svg';
import EyeSmallIconSvg from './eye-small.svg';
import EyeSmallBoldIconSvg from './eye-small-bold.svg';
import EyeMediumIconSvg from './eye-medium.svg';
import EyeMediumBoldIconSvg from './eye-medium-bold.svg';
import EyeLargeIconSvg from './eye-large.svg';
import EyeLargeBoldIconSvg from './eye-large-bold.svg';
import DotsHorizontalXSmallIconSvg from './dots-horizontal-xsmall.svg';
import DotsHorizontalXSmallBoldIconSvg from './dots-horizontal-xsmall-bold.svg';
import DotsHorizontalSmallIconSvg from './dots-horizontal-small.svg';
import DotsHorizontalSmallBoldIconSvg from './dots-horizontal-small-bold.svg';
import DotsHorizontalMediumIconSvg from './dots-horizontal-medium.svg';
import DotsHorizontalMediumBoldIconSvg from './dots-horizontal-medium-bold.svg';
import DotsHorizontalLargeIconSvg from './dots-horizontal-large.svg';
import DotsHorizontalLargeBoldIconSvg from './dots-horizontal-large-bold.svg';
import DotsVerticalXSmallIconSvg from './dots-vertical-xsmall.svg';
import DotsVerticalXSmallBoldIconSvg from './dots-vertical-xsmall-bold.svg';
import DotsVerticalSmallIconSvg from './dots-vertical-small.svg';
import DotsVerticalSmallBoldIconSvg from './dots-vertical-small-bold.svg';
import DotsVerticalMediumIconSvg from './dots-vertical-medium.svg';
import DotsVerticalMediumBoldIconSvg from './dots-vertical-medium-bold.svg';
import DotsVerticalLargeIconSvg from './dots-vertical-large.svg';
import DotsVerticalLargeBoldIconSvg from './dots-vertical-large-bold.svg';
import CalendarDateXSmallIconSvg from './calendar-date-xsmall.svg';
import CalendarDateXSmallBoldIconSvg from './calendar-date-xsmall-bold.svg';
import CalendarDateSmallIconSvg from './calendar-date-small.svg';
import CalendarDateSmallBoldIconSvg from './calendar-date-small-bold.svg';
import CalendarDateMediumIconSvg from './calendar-date-medium.svg';
import CalendarDateMediumBoldIconSvg from './calendar-date-medium-bold.svg';
import CalendarDateLargeIconSvg from './calendar-date-large.svg';
import CalendarDateLargeBoldIconSvg from './calendar-date-large-bold.svg';
import CalendarCheck01XSmallIconSvg from './calendar-check01-xsmall.svg';
import CalendarCheck01XSmallBoldIconSvg from './calendar-check01-xsmall-bold.svg';
import CalendarCheck01SmallIconSvg from './calendar-check01-small.svg';
import CalendarCheck01SmallBoldIconSvg from './calendar-check01-small-bold.svg';
import CalendarCheck01MediumIconSvg from './calendar-check01-medium.svg';
import CalendarCheck01MediumBoldIconSvg from './calendar-check01-medium-bold.svg';
import CalendarCheck01LargeIconSvg from './calendar-check01-large.svg';
import CalendarCheck01LargeBoldIconSvg from './calendar-check01-large-bold.svg';
import CalendarMinus01XSmallIconSvg from './calendar-minus01-xsmall.svg';
import CalendarMinus01XSmallBoldIconSvg from './calendar-minus01-xsmall-bold.svg';
import CalendarMinus01SmallIconSvg from './calendar-minus01-small.svg';
import CalendarMinus01SmallBoldIconSvg from './calendar-minus01-small-bold.svg';
import CalendarMinus01MediumIconSvg from './calendar-minus01-medium.svg';
import CalendarMinus01MediumBoldIconSvg from './calendar-minus01-medium-bold.svg';
import CalendarMinus01LargeIconSvg from './calendar-minus01-large.svg';
import CalendarMinus01LargeBoldIconSvg from './calendar-minus01-large-bold.svg';
import CalendarPlus01XSmallIconSvg from './calendar-plus01-xsmall.svg';
import CalendarPlus01XSmallBoldIconSvg from './calendar-plus01-xsmall-bold.svg';
import CalendarPlus01SmallIconSvg from './calendar-plus01-small.svg';
import CalendarPlus01SmallBoldIconSvg from './calendar-plus01-small-bold.svg';
import CalendarPlus01MediumIconSvg from './calendar-plus01-medium.svg';
import CalendarPlus01MediumBoldIconSvg from './calendar-plus01-medium-bold.svg';
import CalendarPlus01LargeIconSvg from './calendar-plus01-large.svg';
import CalendarPlus01LargeBoldIconSvg from './calendar-plus01-large-bold.svg';
import MessageDotsSquareXSmallIconSvg from './message-dots-square-xsmall.svg';
import MessageDotsSquareXSmallBoldIconSvg from './message-dots-square-xsmall-bold.svg';
import MessageDotsSquareSmallIconSvg from './message-dots-square-small.svg';
import MessageDotsSquareSmallBoldIconSvg from './message-dots-square-small-bold.svg';
import MessageDotsSquareMediumIconSvg from './message-dots-square-medium.svg';
import MessageDotsSquareMediumBoldIconSvg from './message-dots-square-medium-bold.svg';
import MessageDotsSquareLargeIconSvg from './message-dots-square-large.svg';
import MessageDotsSquareLargeBoldIconSvg from './message-dots-square-large-bold.svg';
import CodeSquare01XSmallIconSvg from './code-square01-xsmall.svg';
import CodeSquare01XSmallBoldIconSvg from './code-square01-xsmall-bold.svg';
import CodeSquare01SmallIconSvg from './code-square01-small.svg';
import CodeSquare01SmallBoldIconSvg from './code-square01-small-bold.svg';
import CodeSquare01MediumIconSvg from './code-square01-medium.svg';
import CodeSquare01MediumBoldIconSvg from './code-square01-medium-bold.svg';
import CodeSquare01LargeIconSvg from './code-square01-large.svg';
import CodeSquare01LargeBoldIconSvg from './code-square01-large-bold.svg';
import File04XSmallIconSvg from './file04-xsmall.svg';
import File04XSmallBoldIconSvg from './file04-xsmall-bold.svg';
import File04SmallIconSvg from './file04-small.svg';
import File04SmallBoldIconSvg from './file04-small-bold.svg';
import File04MediumIconSvg from './file04-medium.svg';
import File04MediumBoldIconSvg from './file04-medium-bold.svg';
import File04LargeIconSvg from './file04-large.svg';
import File04LargeBoldIconSvg from './file04-large-bold.svg';
import FileQuestion03XSmallIconSvg from './file-question03-xsmall.svg';
import FileQuestion03XSmallBoldIconSvg from './file-question03-xsmall-bold.svg';
import FileQuestion03SmallIconSvg from './file-question03-small.svg';
import FileQuestion03SmallBoldIconSvg from './file-question03-small-bold.svg';
import FileQuestion03MediumIconSvg from './file-question03-medium.svg';
import FileQuestion03MediumBoldIconSvg from './file-question03-medium-bold.svg';
import FileQuestion03LargeIconSvg from './file-question03-large.svg';
import FileQuestion03LargeBoldIconSvg from './file-question03-large-bold.svg';
import Link03XSmallIconSvg from './link03-xsmall.svg';
import Link03XSmallBoldIconSvg from './link03-xsmall-bold.svg';
import Link03SmallIconSvg from './link03-small.svg';
import Link03SmallBoldIconSvg from './link03-small-bold.svg';
import Link03MediumIconSvg from './link03-medium.svg';
import Link03MediumBoldIconSvg from './link03-medium-bold.svg';
import Link03LargeIconSvg from './link03-large.svg';
import Link03LargeBoldIconSvg from './link03-large-bold.svg';
import LinkBroken01XSmallIconSvg from './link-broken01-xsmall.svg';
import LinkBroken01XSmallBoldIconSvg from './link-broken01-xsmall-bold.svg';
import LinkBroken01SmallIconSvg from './link-broken01-small.svg';
import LinkBroken01SmallBoldIconSvg from './link-broken01-small-bold.svg';
import LinkBroken01MediumIconSvg from './link-broken01-medium.svg';
import LinkBroken01MediumBoldIconSvg from './link-broken01-medium-bold.svg';
import LinkBroken01LargeIconSvg from './link-broken01-large.svg';
import LinkBroken01LargeBoldIconSvg from './link-broken01-large-bold.svg';
import PauseCircleXSmallIconSvg from './pause-circle-xsmall.svg';
import PauseCircleXSmallBoldIconSvg from './pause-circle-xsmall-bold.svg';
import PauseCircleSmallIconSvg from './pause-circle-small.svg';
import PauseCircleSmallBoldIconSvg from './pause-circle-small-bold.svg';
import PauseCircleMediumIconSvg from './pause-circle-medium.svg';
import PauseCircleMediumBoldIconSvg from './pause-circle-medium-bold.svg';
import PauseCircleLargeIconSvg from './pause-circle-large.svg';
import PauseCircleLargeBoldIconSvg from './pause-circle-large-bold.svg';
import ArrowSquareRightXSmallIconSvg from './arrow-square-right-xsmall.svg';
import ArrowSquareRightXSmallBoldIconSvg from './arrow-square-right-xsmall-bold.svg';
import ArrowSquareRightSmallIconSvg from './arrow-square-right-small.svg';
import ArrowSquareRightSmallBoldIconSvg from './arrow-square-right-small-bold.svg';
import ArrowSquareRightMediumIconSvg from './arrow-square-right-medium.svg';
import ArrowSquareRightMediumBoldIconSvg from './arrow-square-right-medium-bold.svg';
import ArrowSquareRightLargeIconSvg from './arrow-square-right-large.svg';
import ArrowSquareRightLargeBoldIconSvg from './arrow-square-right-large-bold.svg';
import Share07XSmallIconSvg from './share07-xsmall.svg';
import Share07XSmallBoldIconSvg from './share07-xsmall-bold.svg';
import Share07SmallIconSvg from './share07-small.svg';
import Share07SmallBoldIconSvg from './share07-small-bold.svg';
import Share07MediumIconSvg from './share07-medium.svg';
import Share07MediumBoldIconSvg from './share07-medium-bold.svg';
import Share07LargeIconSvg from './share07-large.svg';
import Share07LargeBoldIconSvg from './share07-large-bold.svg';
import FilterFunnel01XSmallIconSvg from './filter-funnel01-xsmall.svg';
import FilterFunnel01XSmallBoldIconSvg from './filter-funnel01-xsmall-bold.svg';
import FilterFunnel01SmallIconSvg from './filter-funnel01-small.svg';
import FilterFunnel01SmallBoldIconSvg from './filter-funnel01-small-bold.svg';
import FilterFunnel01MediumIconSvg from './filter-funnel01-medium.svg';
import FilterFunnel01MediumBoldIconSvg from './filter-funnel01-medium-bold.svg';
import FilterFunnel01LargeIconSvg from './filter-funnel01-large.svg';
import FilterFunnel01LargeBoldIconSvg from './filter-funnel01-large-bold.svg';
import Send01XSmallIconSvg from './send01-xsmall.svg';
import Send01XSmallBoldIconSvg from './send01-xsmall-bold.svg';
import Send01SmallIconSvg from './send01-small.svg';
import Send01SmallBoldIconSvg from './send01-small-bold.svg';
import Send01MediumIconSvg from './send01-medium.svg';
import Send01MediumBoldIconSvg from './send01-medium-bold.svg';
import Send01LargeIconSvg from './send01-large.svg';
import Send01LargeBoldIconSvg from './send01-large-bold.svg';
import ChevronLeftXSmallIconSvg from './chevron-left-xsmall.svg';
import ChevronLeftXSmallBoldIconSvg from './chevron-left-xsmall-bold.svg';
import ChevronLeftSmallIconSvg from './chevron-left-small.svg';
import ChevronLeftSmallBoldIconSvg from './chevron-left-small-bold.svg';
import ChevronLeftMediumIconSvg from './chevron-left-medium.svg';
import ChevronLeftMediumBoldIconSvg from './chevron-left-medium-bold.svg';
import ChevronLeftLargeIconSvg from './chevron-left-large.svg';
import ChevronLeftLargeBoldIconSvg from './chevron-left-large-bold.svg';
import ChevronRightXSmallIconSvg from './chevron-right-xsmall.svg';
import ChevronRightXSmallBoldIconSvg from './chevron-right-xsmall-bold.svg';
import ChevronRightSmallIconSvg from './chevron-right-small.svg';
import ChevronRightSmallBoldIconSvg from './chevron-right-small-bold.svg';
import ChevronRightMediumIconSvg from './chevron-right-medium.svg';
import ChevronRightMediumBoldIconSvg from './chevron-right-medium-bold.svg';
import ChevronRightLargeIconSvg from './chevron-right-large.svg';
import ChevronRightLargeBoldIconSvg from './chevron-right-large-bold.svg';
import ChevronUpXSmallIconSvg from './chevron-up-xsmall.svg';
import ChevronUpXSmallBoldIconSvg from './chevron-up-xsmall-bold.svg';
import ChevronUpSmallIconSvg from './chevron-up-small.svg';
import ChevronUpSmallBoldIconSvg from './chevron-up-small-bold.svg';
import ChevronUpMediumIconSvg from './chevron-up-medium.svg';
import ChevronUpMediumBoldIconSvg from './chevron-up-medium-bold.svg';
import ChevronUpLargeIconSvg from './chevron-up-large.svg';
import ChevronUpLargeBoldIconSvg from './chevron-up-large-bold.svg';
import SwitchHorizontal01XSmallIconSvg from './switch-horizontal01-xsmall.svg';
import SwitchHorizontal01XSmallBoldIconSvg from './switch-horizontal01-xsmall-bold.svg';
import SwitchHorizontal01SmallIconSvg from './switch-horizontal01-small.svg';
import SwitchHorizontal01SmallBoldIconSvg from './switch-horizontal01-small-bold.svg';
import SwitchHorizontal01MediumIconSvg from './switch-horizontal01-medium.svg';
import SwitchHorizontal01MediumBoldIconSvg from './switch-horizontal01-medium-bold.svg';
import SwitchHorizontal01LargeIconSvg from './switch-horizontal01-large.svg';
import SwitchHorizontal01LargeBoldIconSvg from './switch-horizontal01-large-bold.svg';
import ArrowSquareDownXSmallIconSvg from './arrow-square-down-xsmall.svg';
import ArrowSquareDownXSmallBoldIconSvg from './arrow-square-down-xsmall-bold.svg';
import ArrowSquareDownSmallIconSvg from './arrow-square-down-small.svg';
import ArrowSquareDownSmallBoldIconSvg from './arrow-square-down-small-bold.svg';
import ArrowSquareDownMediumIconSvg from './arrow-square-down-medium.svg';
import ArrowSquareDownMediumBoldIconSvg from './arrow-square-down-medium-bold.svg';
import ArrowSquareDownLargeIconSvg from './arrow-square-down-large.svg';
import ArrowSquareDownLargeBoldIconSvg from './arrow-square-down-large-bold.svg';
import ArrowSquareLeftXSmallIconSvg from './arrow-square-left-xsmall.svg';
import ArrowSquareLeftXSmallBoldIconSvg from './arrow-square-left-xsmall-bold.svg';
import ArrowSquareLeftSmallIconSvg from './arrow-square-left-small.svg';
import ArrowSquareLeftSmallBoldIconSvg from './arrow-square-left-small-bold.svg';
import ArrowSquareLeftMediumIconSvg from './arrow-square-left-medium.svg';
import ArrowSquareLeftMediumBoldIconSvg from './arrow-square-left-medium-bold.svg';
import ArrowSquareLeftLargeIconSvg from './arrow-square-left-large.svg';
import ArrowSquareLeftLargeBoldIconSvg from './arrow-square-left-large-bold.svg';
import PlayCircleXSmallIconSvg from './play-circle-xsmall.svg';
import PlayCircleXSmallBoldIconSvg from './play-circle-xsmall-bold.svg';
import PlayCircleSmallIconSvg from './play-circle-small.svg';
import PlayCircleSmallBoldIconSvg from './play-circle-small-bold.svg';
import PlayCircleMediumIconSvg from './play-circle-medium.svg';
import PlayCircleMediumBoldIconSvg from './play-circle-medium-bold.svg';
import PlayCircleLargeIconSvg from './play-circle-large.svg';
import PlayCircleLargeBoldIconSvg from './play-circle-large-bold.svg';
import ArrowSquareUpXSmallIconSvg from './arrow-square-up-xsmall.svg';
import ArrowSquareUpXSmallBoldIconSvg from './arrow-square-up-xsmall-bold.svg';
import ArrowSquareUpSmallIconSvg from './arrow-square-up-small.svg';
import ArrowSquareUpSmallBoldIconSvg from './arrow-square-up-small-bold.svg';
import ArrowSquareUpMediumIconSvg from './arrow-square-up-medium.svg';
import ArrowSquareUpMediumBoldIconSvg from './arrow-square-up-medium-bold.svg';
import ArrowSquareUpLargeIconSvg from './arrow-square-up-large.svg';
import ArrowSquareUpLargeBoldIconSvg from './arrow-square-up-large-bold.svg';
import LinkExternal02XSmallIconSvg from './link-external02-xsmall.svg';
import LinkExternal02XSmallBoldIconSvg from './link-external02-xsmall-bold.svg';
import LinkExternal02SmallIconSvg from './link-external02-small.svg';
import LinkExternal02SmallBoldIconSvg from './link-external02-small-bold.svg';
import LinkExternal02MediumIconSvg from './link-external02-medium.svg';
import LinkExternal02MediumBoldIconSvg from './link-external02-medium-bold.svg';
import LinkExternal02LargeIconSvg from './link-external02-large.svg';
import LinkExternal02LargeBoldIconSvg from './link-external02-large-bold.svg';
import ArrowSquareDownRightXSmallIconSvg from './arrow-square-down-right-xsmall.svg';
import ArrowSquareDownRightXSmallBoldIconSvg from './arrow-square-down-right-xsmall-bold.svg';
import ArrowSquareDownRightSmallIconSvg from './arrow-square-down-right-small.svg';
import ArrowSquareDownRightSmallBoldIconSvg from './arrow-square-down-right-small-bold.svg';
import ArrowSquareDownRightMediumIconSvg from './arrow-square-down-right-medium.svg';
import ArrowSquareDownRightMediumBoldIconSvg from './arrow-square-down-right-medium-bold.svg';
import ArrowSquareDownRightLargeIconSvg from './arrow-square-down-right-large.svg';
import ArrowSquareDownRightLargeBoldIconSvg from './arrow-square-down-right-large-bold.svg';
import ArrowSquareUpLeftXSmallIconSvg from './arrow-square-up-left-xsmall.svg';
import ArrowSquareUpLeftXSmallBoldIconSvg from './arrow-square-up-left-xsmall-bold.svg';
import ArrowSquareUpLeftSmallIconSvg from './arrow-square-up-left-small.svg';
import ArrowSquareUpLeftSmallBoldIconSvg from './arrow-square-up-left-small-bold.svg';
import ArrowSquareUpLeftMediumIconSvg from './arrow-square-up-left-medium.svg';
import ArrowSquareUpLeftMediumBoldIconSvg from './arrow-square-up-left-medium-bold.svg';
import ArrowSquareUpLeftLargeIconSvg from './arrow-square-up-left-large.svg';
import ArrowSquareUpLeftLargeBoldIconSvg from './arrow-square-up-left-large-bold.svg';
import ArrowSquareUpRightXSmallIconSvg from './arrow-square-up-right-xsmall.svg';
import ArrowSquareUpRightXSmallBoldIconSvg from './arrow-square-up-right-xsmall-bold.svg';
import ArrowSquareUpRightSmallIconSvg from './arrow-square-up-right-small.svg';
import ArrowSquareUpRightSmallBoldIconSvg from './arrow-square-up-right-small-bold.svg';
import ArrowSquareUpRightMediumIconSvg from './arrow-square-up-right-medium.svg';
import ArrowSquareUpRightMediumBoldIconSvg from './arrow-square-up-right-medium-bold.svg';
import ArrowSquareUpRightLargeIconSvg from './arrow-square-up-right-large.svg';
import ArrowSquareUpRightLargeBoldIconSvg from './arrow-square-up-right-large-bold.svg';
import ArrowLeftXSmallIconSvg from './arrow-left-xsmall.svg';
import ArrowLeftXSmallBoldIconSvg from './arrow-left-xsmall-bold.svg';
import ArrowLeftSmallIconSvg from './arrow-left-small.svg';
import ArrowLeftSmallBoldIconSvg from './arrow-left-small-bold.svg';
import ArrowLeftMediumIconSvg from './arrow-left-medium.svg';
import ArrowLeftMediumBoldIconSvg from './arrow-left-medium-bold.svg';
import ArrowLeftLargeIconSvg from './arrow-left-large.svg';
import ArrowLeftLargeBoldIconSvg from './arrow-left-large-bold.svg';
import ArrowRightXSmallIconSvg from './arrow-right-xsmall.svg';
import ArrowRightXSmallBoldIconSvg from './arrow-right-xsmall-bold.svg';
import ArrowRightSmallIconSvg from './arrow-right-small.svg';
import ArrowRightSmallBoldIconSvg from './arrow-right-small-bold.svg';
import ArrowRightMediumIconSvg from './arrow-right-medium.svg';
import ArrowRightMediumBoldIconSvg from './arrow-right-medium-bold.svg';
import ArrowRightLargeIconSvg from './arrow-right-large.svg';
import ArrowRightLargeBoldIconSvg from './arrow-right-large-bold.svg';
import ArrowUpXSmallIconSvg from './arrow-up-xsmall.svg';
import ArrowUpXSmallBoldIconSvg from './arrow-up-xsmall-bold.svg';
import ArrowUpSmallIconSvg from './arrow-up-small.svg';
import ArrowUpSmallBoldIconSvg from './arrow-up-small-bold.svg';
import ArrowUpMediumIconSvg from './arrow-up-medium.svg';
import ArrowUpMediumBoldIconSvg from './arrow-up-medium-bold.svg';
import ArrowUpLargeIconSvg from './arrow-up-large.svg';
import ArrowUpLargeBoldIconSvg from './arrow-up-large-bold.svg';
import ArrowUpLeftXSmallIconSvg from './arrow-up-left-xsmall.svg';
import ArrowUpLeftXSmallBoldIconSvg from './arrow-up-left-xsmall-bold.svg';
import ArrowUpLeftSmallIconSvg from './arrow-up-left-small.svg';
import ArrowUpLeftSmallBoldIconSvg from './arrow-up-left-small-bold.svg';
import ArrowUpLeftMediumIconSvg from './arrow-up-left-medium.svg';
import ArrowUpLeftMediumBoldIconSvg from './arrow-up-left-medium-bold.svg';
import ArrowUpLeftLargeIconSvg from './arrow-up-left-large.svg';
import ArrowUpLeftLargeBoldIconSvg from './arrow-up-left-large-bold.svg';
import ArrowUpRightXSmallIconSvg from './arrow-up-right-xsmall.svg';
import ArrowUpRightXSmallBoldIconSvg from './arrow-up-right-xsmall-bold.svg';
import ArrowUpRightSmallIconSvg from './arrow-up-right-small.svg';
import ArrowUpRightSmallBoldIconSvg from './arrow-up-right-small-bold.svg';
import ArrowUpRightMediumIconSvg from './arrow-up-right-medium.svg';
import ArrowUpRightMediumBoldIconSvg from './arrow-up-right-medium-bold.svg';
import ArrowUpRightLargeIconSvg from './arrow-up-right-large.svg';
import ArrowUpRightLargeBoldIconSvg from './arrow-up-right-large-bold.svg';
import ArrowSquareDownLeftXSmallIconSvg from './arrow-square-down-left-xsmall.svg';
import ArrowSquareDownLeftXSmallBoldIconSvg from './arrow-square-down-left-xsmall-bold.svg';
import ArrowSquareDownLeftSmallIconSvg from './arrow-square-down-left-small.svg';
import ArrowSquareDownLeftSmallBoldIconSvg from './arrow-square-down-left-small-bold.svg';
import ArrowSquareDownLeftMediumIconSvg from './arrow-square-down-left-medium.svg';
import ArrowSquareDownLeftMediumBoldIconSvg from './arrow-square-down-left-medium-bold.svg';
import ArrowSquareDownLeftLargeIconSvg from './arrow-square-down-left-large.svg';
import ArrowSquareDownLeftLargeBoldIconSvg from './arrow-square-down-left-large-bold.svg';
import ArrowDownXSmallIconSvg from './arrow-down-xsmall.svg';
import ArrowDownXSmallBoldIconSvg from './arrow-down-xsmall-bold.svg';
import ArrowDownSmallIconSvg from './arrow-down-small.svg';
import ArrowDownSmallBoldIconSvg from './arrow-down-small-bold.svg';
import ArrowDownMediumIconSvg from './arrow-down-medium.svg';
import ArrowDownMediumBoldIconSvg from './arrow-down-medium-bold.svg';
import ArrowDownLargeIconSvg from './arrow-down-large.svg';
import ArrowDownLargeBoldIconSvg from './arrow-down-large-bold.svg';
import ArrowDownLeftXSmallIconSvg from './arrow-down-left-xsmall.svg';
import ArrowDownLeftXSmallBoldIconSvg from './arrow-down-left-xsmall-bold.svg';
import ArrowDownLeftSmallIconSvg from './arrow-down-left-small.svg';
import ArrowDownLeftSmallBoldIconSvg from './arrow-down-left-small-bold.svg';
import ArrowDownLeftMediumIconSvg from './arrow-down-left-medium.svg';
import ArrowDownLeftMediumBoldIconSvg from './arrow-down-left-medium-bold.svg';
import ArrowDownLeftLargeIconSvg from './arrow-down-left-large.svg';
import ArrowDownLeftLargeBoldIconSvg from './arrow-down-left-large-bold.svg';
import ArrowDownRightXSmallIconSvg from './arrow-down-right-xsmall.svg';
import ArrowDownRightXSmallBoldIconSvg from './arrow-down-right-xsmall-bold.svg';
import ArrowDownRightSmallIconSvg from './arrow-down-right-small.svg';
import ArrowDownRightSmallBoldIconSvg from './arrow-down-right-small-bold.svg';
import ArrowDownRightMediumIconSvg from './arrow-down-right-medium.svg';
import ArrowDownRightMediumBoldIconSvg from './arrow-down-right-medium-bold.svg';
import ArrowDownRightLargeIconSvg from './arrow-down-right-large.svg';
import ArrowDownRightLargeBoldIconSvg from './arrow-down-right-large-bold.svg';
import CheckCircleXSmallIconSvg from './check-circle-xsmall.svg';
import CheckCircleXSmallBoldIconSvg from './check-circle-xsmall-bold.svg';
import CheckCircleSmallIconSvg from './check-circle-small.svg';
import CheckCircleSmallBoldIconSvg from './check-circle-small-bold.svg';
import CheckCircleMediumIconSvg from './check-circle-medium.svg';
import CheckCircleMediumBoldIconSvg from './check-circle-medium-bold.svg';
import CheckCircleLargeIconSvg from './check-circle-large.svg';
import CheckCircleLargeBoldIconSvg from './check-circle-large-bold.svg';
import Download01XSmallIconSvg from './download01-xsmall.svg';
import Download01XSmallBoldIconSvg from './download01-xsmall-bold.svg';
import Download01SmallIconSvg from './download01-small.svg';
import Download01SmallBoldIconSvg from './download01-small-bold.svg';
import Download01MediumIconSvg from './download01-medium.svg';
import Download01MediumBoldIconSvg from './download01-medium-bold.svg';
import Download01LargeIconSvg from './download01-large.svg';
import Download01LargeBoldIconSvg from './download01-large-bold.svg';
import CheckXSmallIconSvg from './check-xsmall.svg';
import CheckXSmallBoldIconSvg from './check-xsmall-bold.svg';
import CheckSmallIconSvg from './check-small.svg';
import CheckSmallBoldIconSvg from './check-small-bold.svg';
import CheckMediumIconSvg from './check-medium.svg';
import CheckMediumBoldIconSvg from './check-medium-bold.svg';
import CheckLargeIconSvg from './check-large.svg';
import CheckLargeBoldIconSvg from './check-large-bold.svg';
import RefreshCcw02XSmallIconSvg from './refresh-ccw02-xsmall.svg';
import RefreshCcw02XSmallBoldIconSvg from './refresh-ccw02-xsmall-bold.svg';
import RefreshCcw02SmallIconSvg from './refresh-ccw02-small.svg';
import RefreshCcw02SmallBoldIconSvg from './refresh-ccw02-small-bold.svg';
import RefreshCcw02MediumIconSvg from './refresh-ccw02-medium.svg';
import RefreshCcw02MediumBoldIconSvg from './refresh-ccw02-medium-bold.svg';
import RefreshCcw02LargeIconSvg from './refresh-ccw02-large.svg';
import RefreshCcw02LargeBoldIconSvg from './refresh-ccw02-large-bold.svg';
import RefreshCcw01XSmallIconSvg from './refresh-ccw01-xsmall.svg';
import RefreshCcw01XSmallBoldIconSvg from './refresh-ccw01-xsmall-bold.svg';
import RefreshCcw01SmallIconSvg from './refresh-ccw01-small.svg';
import RefreshCcw01SmallBoldIconSvg from './refresh-ccw01-small-bold.svg';
import RefreshCcw01MediumIconSvg from './refresh-ccw01-medium.svg';
import RefreshCcw01MediumBoldIconSvg from './refresh-ccw01-medium-bold.svg';
import RefreshCcw01LargeIconSvg from './refresh-ccw01-large.svg';
import RefreshCcw01LargeBoldIconSvg from './refresh-ccw01-large-bold.svg';
import LogOut01XSmallIconSvg from './log-out01-xsmall.svg';
import LogOut01XSmallBoldIconSvg from './log-out01-xsmall-bold.svg';
import LogOut01SmallIconSvg from './log-out01-small.svg';
import LogOut01SmallBoldIconSvg from './log-out01-small-bold.svg';
import LogOut01MediumIconSvg from './log-out01-medium.svg';
import LogOut01MediumBoldIconSvg from './log-out01-medium-bold.svg';
import LogOut01LargeIconSvg from './log-out01-large.svg';
import LogOut01LargeBoldIconSvg from './log-out01-large-bold.svg';
import Expand01XSmallIconSvg from './expand01-xsmall.svg';
import Expand01XSmallBoldIconSvg from './expand01-xsmall-bold.svg';
import Expand01SmallIconSvg from './expand01-small.svg';
import Expand01SmallBoldIconSvg from './expand01-small-bold.svg';
import Expand01MediumIconSvg from './expand01-medium.svg';
import Expand01MediumBoldIconSvg from './expand01-medium-bold.svg';
import Expand01LargeIconSvg from './expand01-large.svg';
import Expand01LargeBoldIconSvg from './expand01-large-bold.svg';
import LogIn01XSmallIconSvg from './log-in01-xsmall.svg';
import LogIn01XSmallBoldIconSvg from './log-in01-xsmall-bold.svg';
import LogIn01SmallIconSvg from './log-in01-small.svg';
import LogIn01SmallBoldIconSvg from './log-in01-small-bold.svg';
import LogIn01MediumIconSvg from './log-in01-medium.svg';
import LogIn01MediumBoldIconSvg from './log-in01-medium-bold.svg';
import LogIn01LargeIconSvg from './log-in01-large.svg';
import LogIn01LargeBoldIconSvg from './log-in01-large-bold.svg';
import Share02XSmallIconSvg from './share02-xsmall.svg';
import Share02XSmallBoldIconSvg from './share02-xsmall-bold.svg';
import Share02SmallIconSvg from './share02-small.svg';
import Share02SmallBoldIconSvg from './share02-small-bold.svg';
import Share02MediumIconSvg from './share02-medium.svg';
import Share02MediumBoldIconSvg from './share02-medium-bold.svg';
import Share02LargeIconSvg from './share02-large.svg';
import Share02LargeBoldIconSvg from './share02-large-bold.svg';
import XCloseXSmallIconSvg from './xclose-xsmall.svg';
import XCloseXSmallBoldIconSvg from './xclose-xsmall-bold.svg';
import XCloseSmallIconSvg from './xclose-small.svg';
import XCloseSmallBoldIconSvg from './xclose-small-bold.svg';
import XCloseMediumIconSvg from './xclose-medium.svg';
import XCloseMediumBoldIconSvg from './xclose-medium-bold.svg';
import XCloseLargeIconSvg from './xclose-large.svg';
import XCloseLargeBoldIconSvg from './xclose-large-bold.svg';
import XXSmallIconSvg from './x-xsmall.svg';
import XXSmallBoldIconSvg from './x-xsmall-bold.svg';
import XSmallIconSvg from './x-small.svg';
import XSmallBoldIconSvg from './x-small-bold.svg';
import XMediumIconSvg from './x-medium.svg';
import XMediumBoldIconSvg from './x-medium-bold.svg';
import XLargeIconSvg from './x-large.svg';
import XLargeBoldIconSvg from './x-large-bold.svg';
import XCircleXSmallIconSvg from './xcircle-xsmall.svg';
import XCircleXSmallBoldIconSvg from './xcircle-xsmall-bold.svg';
import XCircleSmallIconSvg from './xcircle-small.svg';
import XCircleSmallBoldIconSvg from './xcircle-small-bold.svg';
import XCircleMediumIconSvg from './xcircle-medium.svg';
import XCircleMediumBoldIconSvg from './xcircle-medium-bold.svg';
import XCircleLargeIconSvg from './xcircle-large.svg';
import XCircleLargeBoldIconSvg from './xcircle-large-bold.svg';
import HelpCircleXSmallIconSvg from './help-circle-xsmall.svg';
import HelpCircleXSmallBoldIconSvg from './help-circle-xsmall-bold.svg';
import HelpCircleSmallIconSvg from './help-circle-small.svg';
import HelpCircleSmallBoldIconSvg from './help-circle-small-bold.svg';
import HelpCircleMediumIconSvg from './help-circle-medium.svg';
import HelpCircleMediumBoldIconSvg from './help-circle-medium-bold.svg';
import HelpCircleLargeIconSvg from './help-circle-large.svg';
import HelpCircleLargeBoldIconSvg from './help-circle-large-bold.svg';
import InfoCircleXSmallIconSvg from './info-circle-xsmall.svg';
import InfoCircleXSmallBoldIconSvg from './info-circle-xsmall-bold.svg';
import InfoCircleSmallIconSvg from './info-circle-small.svg';
import InfoCircleSmallBoldIconSvg from './info-circle-small-bold.svg';
import InfoCircleMediumIconSvg from './info-circle-medium.svg';
import InfoCircleMediumBoldIconSvg from './info-circle-medium-bold.svg';
import InfoCircleLargeIconSvg from './info-circle-large.svg';
import InfoCircleLargeBoldIconSvg from './info-circle-large-bold.svg';
import HeartRoundedXSmallIconSvg from './heart-rounded-xsmall.svg';
import HeartRoundedXSmallBoldIconSvg from './heart-rounded-xsmall-bold.svg';
import HeartRoundedSmallIconSvg from './heart-rounded-small.svg';
import HeartRoundedSmallBoldIconSvg from './heart-rounded-small-bold.svg';
import HeartRoundedMediumIconSvg from './heart-rounded-medium.svg';
import HeartRoundedMediumBoldIconSvg from './heart-rounded-medium-bold.svg';
import HeartRoundedLargeIconSvg from './heart-rounded-large.svg';
import HeartRoundedLargeBoldIconSvg from './heart-rounded-large-bold.svg';
import CurrencyDollarCircleXSmallIconSvg from './currency-dollar-circle-xsmall.svg';
import CurrencyDollarCircleXSmallBoldIconSvg from './currency-dollar-circle-xsmall-bold.svg';
import CurrencyDollarCircleSmallIconSvg from './currency-dollar-circle-small.svg';
import CurrencyDollarCircleSmallBoldIconSvg from './currency-dollar-circle-small-bold.svg';
import CurrencyDollarCircleMediumIconSvg from './currency-dollar-circle-medium.svg';
import CurrencyDollarCircleMediumBoldIconSvg from './currency-dollar-circle-medium-bold.svg';
import CurrencyDollarCircleLargeIconSvg from './currency-dollar-circle-large.svg';
import CurrencyDollarCircleLargeBoldIconSvg from './currency-dollar-circle-large-bold.svg';
import Lock01XSmallIconSvg from './lock01-xsmall.svg';
import Lock01XSmallBoldIconSvg from './lock01-xsmall-bold.svg';
import Lock01SmallIconSvg from './lock01-small.svg';
import Lock01SmallBoldIconSvg from './lock01-small-bold.svg';
import Lock01MediumIconSvg from './lock01-medium.svg';
import Lock01MediumBoldIconSvg from './lock01-medium-bold.svg';
import Lock01LargeIconSvg from './lock01-large.svg';
import Lock01LargeBoldIconSvg from './lock01-large-bold.svg';
import LockUnlocked01XSmallIconSvg from './lock-unlocked01-xsmall.svg';
import LockUnlocked01XSmallBoldIconSvg from './lock-unlocked01-xsmall-bold.svg';
import LockUnlocked01SmallIconSvg from './lock-unlocked01-small.svg';
import LockUnlocked01SmallBoldIconSvg from './lock-unlocked01-small-bold.svg';
import LockUnlocked01MediumIconSvg from './lock-unlocked01-medium.svg';
import LockUnlocked01MediumBoldIconSvg from './lock-unlocked01-medium-bold.svg';
import LockUnlocked01LargeIconSvg from './lock-unlocked01-large.svg';
import LockUnlocked01LargeBoldIconSvg from './lock-unlocked01-large-bold.svg';
import ClockXSmallIconSvg from './clock-xsmall.svg';
import ClockXSmallBoldIconSvg from './clock-xsmall-bold.svg';
import ClockSmallIconSvg from './clock-small.svg';
import ClockSmallBoldIconSvg from './clock-small-bold.svg';
import ClockMediumIconSvg from './clock-medium.svg';
import ClockMediumBoldIconSvg from './clock-medium-bold.svg';
import ClockLargeIconSvg from './clock-large.svg';
import ClockLargeBoldIconSvg from './clock-large-bold.svg';
import Recording02XSmallIconSvg from './recording02-xsmall.svg';
import Recording02XSmallBoldIconSvg from './recording02-xsmall-bold.svg';
import Recording02SmallIconSvg from './recording02-small.svg';
import Recording02SmallBoldIconSvg from './recording02-small-bold.svg';
import Recording02MediumIconSvg from './recording02-medium.svg';
import Recording02MediumBoldIconSvg from './recording02-medium-bold.svg';
import Recording02LargeIconSvg from './recording02-large.svg';
import Recording02LargeBoldIconSvg from './recording02-large-bold.svg';
import BrowserXSmallIconSvg from './browser-xsmall.svg';
import BrowserXSmallBoldIconSvg from './browser-xsmall-bold.svg';
import BrowserSmallIconSvg from './browser-small.svg';
import BrowserSmallBoldIconSvg from './browser-small-bold.svg';
import BrowserMediumIconSvg from './browser-medium.svg';
import BrowserMediumBoldIconSvg from './browser-medium-bold.svg';
import BrowserLargeIconSvg from './browser-large.svg';
import BrowserLargeBoldIconSvg from './browser-large-bold.svg';
import Mail01XSmallIconSvg from './mail01-xsmall.svg';
import Mail01XSmallBoldIconSvg from './mail01-xsmall-bold.svg';
import Mail01SmallIconSvg from './mail01-small.svg';
import Mail01SmallBoldIconSvg from './mail01-small-bold.svg';
import Mail01MediumIconSvg from './mail01-medium.svg';
import Mail01MediumBoldIconSvg from './mail01-medium-bold.svg';
import Mail01LargeIconSvg from './mail01-large.svg';
import Mail01LargeBoldIconSvg from './mail01-large-bold.svg';
import MarkerPin01XSmallIconSvg from './marker-pin01-xsmall.svg';
import MarkerPin01XSmallBoldIconSvg from './marker-pin01-xsmall-bold.svg';
import MarkerPin01SmallIconSvg from './marker-pin01-small.svg';
import MarkerPin01SmallBoldIconSvg from './marker-pin01-small-bold.svg';
import MarkerPin01MediumIconSvg from './marker-pin01-medium.svg';
import MarkerPin01MediumBoldIconSvg from './marker-pin01-medium-bold.svg';
import MarkerPin01LargeIconSvg from './marker-pin01-large.svg';
import MarkerPin01LargeBoldIconSvg from './marker-pin01-large-bold.svg';
import Settings03XSmallIconSvg from './settings03-xsmall.svg';
import Settings03XSmallBoldIconSvg from './settings03-xsmall-bold.svg';
import Settings03SmallIconSvg from './settings03-small.svg';
import Settings03SmallBoldIconSvg from './settings03-small-bold.svg';
import Settings03MediumIconSvg from './settings03-medium.svg';
import Settings03MediumBoldIconSvg from './settings03-medium-bold.svg';
import Settings03LargeIconSvg from './settings03-large.svg';
import Settings03LargeBoldIconSvg from './settings03-large-bold.svg';
import Settings04XSmallIconSvg from './settings04-xsmall.svg';
import Settings04XSmallBoldIconSvg from './settings04-xsmall-bold.svg';
import Settings04SmallIconSvg from './settings04-small.svg';
import Settings04SmallBoldIconSvg from './settings04-small-bold.svg';
import Settings04MediumIconSvg from './settings04-medium.svg';
import Settings04MediumBoldIconSvg from './settings04-medium-bold.svg';
import Settings04LargeIconSvg from './settings04-large.svg';
import Settings04LargeBoldIconSvg from './settings04-large-bold.svg';
import Code02XSmallIconSvg from './code02-xsmall.svg';
import Code02XSmallBoldIconSvg from './code02-xsmall-bold.svg';
import Code02SmallIconSvg from './code02-small.svg';
import Code02SmallBoldIconSvg from './code02-small-bold.svg';
import Code02MediumIconSvg from './code02-medium.svg';
import Code02MediumBoldIconSvg from './code02-medium-bold.svg';
import Code02LargeIconSvg from './code02-large.svg';
import Code02LargeBoldIconSvg from './code02-large-bold.svg';
import Bot01XSmallIconSvg from './bot01-xsmall.svg';
import Bot01XSmallBoldIconSvg from './bot01-xsmall-bold.svg';
import Bot01SmallIconSvg from './bot01-small.svg';
import Bot01SmallBoldIconSvg from './bot01-small-bold.svg';
import Bot01MediumIconSvg from './bot01-medium.svg';
import Bot01MediumBoldIconSvg from './bot01-medium-bold.svg';
import Bot01LargeIconSvg from './bot01-large.svg';
import Bot01LargeBoldIconSvg from './bot01-large-bold.svg';
import Rocket02XSmallIconSvg from './rocket02-xsmall.svg';
import Rocket02XSmallBoldIconSvg from './rocket02-xsmall-bold.svg';
import Rocket02SmallIconSvg from './rocket02-small.svg';
import Rocket02SmallBoldIconSvg from './rocket02-small-bold.svg';
import Rocket02MediumIconSvg from './rocket02-medium.svg';
import Rocket02MediumBoldIconSvg from './rocket02-medium-bold.svg';
import Rocket02LargeIconSvg from './rocket02-large.svg';
import Rocket02LargeBoldIconSvg from './rocket02-large-bold.svg';
import Copy03AiXSmallIconSvg from './copy03-ai-xsmall.svg';
import Copy03AiXSmallBoldIconSvg from './copy03-ai-xsmall-bold.svg';
import Copy03AiSmallIconSvg from './copy03-ai-small.svg';
import Copy03AiSmallBoldIconSvg from './copy03-ai-small-bold.svg';
import Copy03AiMediumIconSvg from './copy03-ai-medium.svg';
import Copy03AiMediumBoldIconSvg from './copy03-ai-medium-bold.svg';
import Copy03AiLargeIconSvg from './copy03-ai-large.svg';
import Copy03AiLargeBoldIconSvg from './copy03-ai-large-bold.svg';
import MappingXSmallIconSvg from './mapping-xsmall.svg';
import MappingXSmallBoldIconSvg from './mapping-xsmall-bold.svg';
import MappingSmallIconSvg from './mapping-small.svg';
import MappingSmallBoldIconSvg from './mapping-small-bold.svg';
import MappingMediumIconSvg from './mapping-medium.svg';
import MappingMediumBoldIconSvg from './mapping-medium-bold.svg';
import MappingLargeIconSvg from './mapping-large.svg';
import MappingLargeBoldIconSvg from './mapping-large-bold.svg';
import Tag01XSmallIconSvg from './tag01-xsmall.svg';
import Tag01XSmallBoldIconSvg from './tag01-xsmall-bold.svg';
import Tag01SmallIconSvg from './tag01-small.svg';
import Tag01SmallBoldIconSvg from './tag01-small-bold.svg';
import Tag01MediumIconSvg from './tag01-medium.svg';
import Tag01MediumBoldIconSvg from './tag01-medium-bold.svg';
import Tag01LargeIconSvg from './tag01-large.svg';
import Tag01LargeBoldIconSvg from './tag01-large-bold.svg';
import CreditCardCheckXSmallIconSvg from './credit-card-check-xsmall.svg';
import CreditCardCheckXSmallBoldIconSvg from './credit-card-check-xsmall-bold.svg';
import CreditCardCheckSmallIconSvg from './credit-card-check-small.svg';
import CreditCardCheckSmallBoldIconSvg from './credit-card-check-small-bold.svg';
import CreditCardCheckMediumIconSvg from './credit-card-check-medium.svg';
import CreditCardCheckMediumBoldIconSvg from './credit-card-check-medium-bold.svg';
import CreditCardCheckLargeIconSvg from './credit-card-check-large.svg';
import CreditCardCheckLargeBoldIconSvg from './credit-card-check-large-bold.svg';
import SwitchVertical01XSmallIconSvg from './switch-vertical-01-xsmall.svg';
import SwitchVertical01XSmallBoldIconSvg from './switch-vertical-01-xsmall-bold.svg';
import SwitchVertical01SmallIconSvg from './switch-vertical-01-small.svg';
import SwitchVertical01SmallBoldIconSvg from './switch-vertical-01-small-bold.svg';
import SwitchVertical01MediumIconSvg from './switch-vertical-01-medium.svg';
import SwitchVertical01MediumBoldIconSvg from './switch-vertical-01-medium-bold.svg';
import SwitchVertical01LargeIconSvg from './switch-vertical-01-large.svg';
import SwitchVertical01LargeBoldIconSvg from './switch-vertical-01-large-bold.svg';

export const CopyXSmallIcon = createIcon(
  CopyXSmallIconSvg,
  'CopyXSmallIcon',
  12
);
export const CopyXSmallBoldIcon = createIcon(
  CopyXSmallBoldIconSvg,
  'CopyXSmallBoldIcon',
  12
);
export const CopySmallIcon = createIcon(CopySmallIconSvg, 'CopySmallIcon', 16);
export const CopySmallBoldIcon = createIcon(
  CopySmallBoldIconSvg,
  'CopySmallBoldIcon',
  16
);
export const CopyMediumIcon = createIcon(
  CopyMediumIconSvg,
  'CopyMediumIcon',
  20
);
export const CopyMediumBoldIcon = createIcon(
  CopyMediumBoldIconSvg,
  'CopyMediumBoldIcon',
  20
);
export const CopyLargeIcon = createIcon(CopyLargeIconSvg, 'CopyLargeIcon', 24);
export const CopyLargeBoldIcon = createIcon(
  CopyLargeBoldIconSvg,
  'CopyLargeBoldIcon',
  24
);
export const ChevronDownXSmallIcon = createIcon(
  ChevronDownXSmallIconSvg,
  'ChevronDownXSmallIcon',
  12
);
export const ChevronDownXSmallBoldIcon = createIcon(
  ChevronDownXSmallBoldIconSvg,
  'ChevronDownXSmallBoldIcon',
  12
);
export const ChevronDownSmallIcon = createIcon(
  ChevronDownSmallIconSvg,
  'ChevronDownSmallIcon',
  16
);
export const ChevronDownSmallBoldIcon = createIcon(
  ChevronDownSmallBoldIconSvg,
  'ChevronDownSmallBoldIcon',
  16
);
export const ChevronDownMediumIcon = createIcon(
  ChevronDownMediumIconSvg,
  'ChevronDownMediumIcon',
  20
);
export const ChevronDownMediumBoldIcon = createIcon(
  ChevronDownMediumBoldIconSvg,
  'ChevronDownMediumBoldIcon',
  20
);
export const ChevronDownLargeIcon = createIcon(
  ChevronDownLargeIconSvg,
  'ChevronDownLargeIcon',
  24
);
export const ChevronDownLargeBoldIcon = createIcon(
  ChevronDownLargeBoldIconSvg,
  'ChevronDownLargeBoldIcon',
  24
);
export const EyeOffXSmallIcon = createIcon(
  EyeOffXSmallIconSvg,
  'EyeOffXSmallIcon',
  12
);
export const EyeOffXSmallBoldIcon = createIcon(
  EyeOffXSmallBoldIconSvg,
  'EyeOffXSmallBoldIcon',
  12
);
export const EyeOffSmallIcon = createIcon(
  EyeOffSmallIconSvg,
  'EyeOffSmallIcon',
  16
);
export const EyeOffSmallBoldIcon = createIcon(
  EyeOffSmallBoldIconSvg,
  'EyeOffSmallBoldIcon',
  16
);
export const EyeOffMediumIcon = createIcon(
  EyeOffMediumIconSvg,
  'EyeOffMediumIcon',
  20
);
export const EyeOffMediumBoldIcon = createIcon(
  EyeOffMediumBoldIconSvg,
  'EyeOffMediumBoldIcon',
  20
);
export const EyeOffLargeIcon = createIcon(
  EyeOffLargeIconSvg,
  'EyeOffLargeIcon',
  24
);
export const EyeOffLargeBoldIcon = createIcon(
  EyeOffLargeBoldIconSvg,
  'EyeOffLargeBoldIcon',
  24
);
export const Trash01XSmallIcon = createIcon(
  Trash01XSmallIconSvg,
  'Trash01XSmallIcon',
  12
);
export const Trash01XSmallBoldIcon = createIcon(
  Trash01XSmallBoldIconSvg,
  'Trash01XSmallBoldIcon',
  12
);
export const Trash01SmallIcon = createIcon(
  Trash01SmallIconSvg,
  'Trash01SmallIcon',
  16
);
export const Trash01SmallBoldIcon = createIcon(
  Trash01SmallBoldIconSvg,
  'Trash01SmallBoldIcon',
  16
);
export const Trash01MediumIcon = createIcon(
  Trash01MediumIconSvg,
  'Trash01MediumIcon',
  20
);
export const Trash01MediumBoldIcon = createIcon(
  Trash01MediumBoldIconSvg,
  'Trash01MediumBoldIcon',
  20
);
export const Trash01LargeIcon = createIcon(
  Trash01LargeIconSvg,
  'Trash01LargeIcon',
  24
);
export const Trash01LargeBoldIcon = createIcon(
  Trash01LargeBoldIconSvg,
  'Trash01LargeBoldIcon',
  24
);
export const SearchXSmallIcon = createIcon(
  SearchXSmallIconSvg,
  'SearchXSmallIcon',
  12
);
export const SearchXSmallBoldIcon = createIcon(
  SearchXSmallBoldIconSvg,
  'SearchXSmallBoldIcon',
  12
);
export const SearchSmallIcon = createIcon(
  SearchSmallIconSvg,
  'SearchSmallIcon',
  16
);
export const SearchSmallBoldIcon = createIcon(
  SearchSmallBoldIconSvg,
  'SearchSmallBoldIcon',
  16
);
export const SearchMediumIcon = createIcon(
  SearchMediumIconSvg,
  'SearchMediumIcon',
  20
);
export const SearchMediumBoldIcon = createIcon(
  SearchMediumBoldIconSvg,
  'SearchMediumBoldIcon',
  20
);
export const SearchLargeIcon = createIcon(
  SearchLargeIconSvg,
  'SearchLargeIcon',
  24
);
export const SearchLargeBoldIcon = createIcon(
  SearchLargeBoldIconSvg,
  'SearchLargeBoldIcon',
  24
);
export const PlusXSmallIcon = createIcon(
  PlusXSmallIconSvg,
  'PlusXSmallIcon',
  12
);
export const PlusXSmallBoldIcon = createIcon(
  PlusXSmallBoldIconSvg,
  'PlusXSmallBoldIcon',
  12
);
export const PlusSmallIcon = createIcon(PlusSmallIconSvg, 'PlusSmallIcon', 16);
export const PlusSmallBoldIcon = createIcon(
  PlusSmallBoldIconSvg,
  'PlusSmallBoldIcon',
  16
);
export const PlusMediumIcon = createIcon(
  PlusMediumIconSvg,
  'PlusMediumIcon',
  20
);
export const PlusMediumBoldIcon = createIcon(
  PlusMediumBoldIconSvg,
  'PlusMediumBoldIcon',
  20
);
export const PlusLargeIcon = createIcon(PlusLargeIconSvg, 'PlusLargeIcon', 24);
export const PlusLargeBoldIcon = createIcon(
  PlusLargeBoldIconSvg,
  'PlusLargeBoldIcon',
  24
);
export const MinusXSmallIcon = createIcon(
  MinusXSmallIconSvg,
  'MinusXSmallIcon',
  12
);
export const MinusXSmallBoldIcon = createIcon(
  MinusXSmallBoldIconSvg,
  'MinusXSmallBoldIcon',
  12
);
export const MinusSmallIcon = createIcon(
  MinusSmallIconSvg,
  'MinusSmallIcon',
  16
);
export const MinusSmallBoldIcon = createIcon(
  MinusSmallBoldIconSvg,
  'MinusSmallBoldIcon',
  16
);
export const MinusMediumIcon = createIcon(
  MinusMediumIconSvg,
  'MinusMediumIcon',
  20
);
export const MinusMediumBoldIcon = createIcon(
  MinusMediumBoldIconSvg,
  'MinusMediumBoldIcon',
  20
);
export const MinusLargeIcon = createIcon(
  MinusLargeIconSvg,
  'MinusLargeIcon',
  24
);
export const MinusLargeBoldIcon = createIcon(
  MinusLargeBoldIconSvg,
  'MinusLargeBoldIcon',
  24
);
export const Menu01XSmallIcon = createIcon(
  Menu01XSmallIconSvg,
  'Menu01XSmallIcon',
  12
);
export const Menu01XSmallBoldIcon = createIcon(
  Menu01XSmallBoldIconSvg,
  'Menu01XSmallBoldIcon',
  12
);
export const Menu01SmallIcon = createIcon(
  Menu01SmallIconSvg,
  'Menu01SmallIcon',
  16
);
export const Menu01SmallBoldIcon = createIcon(
  Menu01SmallBoldIconSvg,
  'Menu01SmallBoldIcon',
  16
);
export const Menu01MediumIcon = createIcon(
  Menu01MediumIconSvg,
  'Menu01MediumIcon',
  20
);
export const Menu01MediumBoldIcon = createIcon(
  Menu01MediumBoldIconSvg,
  'Menu01MediumBoldIcon',
  20
);
export const Menu01LargeIcon = createIcon(
  Menu01LargeIconSvg,
  'Menu01LargeIcon',
  24
);
export const Menu01LargeBoldIcon = createIcon(
  Menu01LargeBoldIconSvg,
  'Menu01LargeBoldIcon',
  24
);
export const Settings01XSmallIcon = createIcon(
  Settings01XSmallIconSvg,
  'Settings01XSmallIcon',
  12
);
export const Settings01XSmallBoldIcon = createIcon(
  Settings01XSmallBoldIconSvg,
  'Settings01XSmallBoldIcon',
  12
);
export const Settings01SmallIcon = createIcon(
  Settings01SmallIconSvg,
  'Settings01SmallIcon',
  16
);
export const Settings01SmallBoldIcon = createIcon(
  Settings01SmallBoldIconSvg,
  'Settings01SmallBoldIcon',
  16
);
export const Settings01MediumIcon = createIcon(
  Settings01MediumIconSvg,
  'Settings01MediumIcon',
  20
);
export const Settings01MediumBoldIcon = createIcon(
  Settings01MediumBoldIconSvg,
  'Settings01MediumBoldIcon',
  20
);
export const Settings01LargeIcon = createIcon(
  Settings01LargeIconSvg,
  'Settings01LargeIcon',
  24
);
export const Settings01LargeBoldIcon = createIcon(
  Settings01LargeBoldIconSvg,
  'Settings01LargeBoldIcon',
  24
);
export const Target03XSmallIcon = createIcon(
  Target03XSmallIconSvg,
  'Target03XSmallIcon',
  12
);
export const Target03XSmallBoldIcon = createIcon(
  Target03XSmallBoldIconSvg,
  'Target03XSmallBoldIcon',
  12
);
export const Target03SmallIcon = createIcon(
  Target03SmallIconSvg,
  'Target03SmallIcon',
  16
);
export const Target03SmallBoldIcon = createIcon(
  Target03SmallBoldIconSvg,
  'Target03SmallBoldIcon',
  16
);
export const Target03MediumIcon = createIcon(
  Target03MediumIconSvg,
  'Target03MediumIcon',
  20
);
export const Target03MediumBoldIcon = createIcon(
  Target03MediumBoldIconSvg,
  'Target03MediumBoldIcon',
  20
);
export const Target03LargeIcon = createIcon(
  Target03LargeIconSvg,
  'Target03LargeIcon',
  24
);
export const Target03LargeBoldIcon = createIcon(
  Target03LargeBoldIconSvg,
  'Target03LargeBoldIcon',
  24
);
export const Star01XSmallIcon = createIcon(
  Star01XSmallIconSvg,
  'Star01XSmallIcon',
  12
);
export const Star01XSmallBoldIcon = createIcon(
  Star01XSmallBoldIconSvg,
  'Star01XSmallBoldIcon',
  12
);
export const Star01SmallIcon = createIcon(
  Star01SmallIconSvg,
  'Star01SmallIcon',
  16
);
export const Star01SmallBoldIcon = createIcon(
  Star01SmallBoldIconSvg,
  'Star01SmallBoldIcon',
  16
);
export const Star01MediumIcon = createIcon(
  Star01MediumIconSvg,
  'Star01MediumIcon',
  20
);
export const Star01MediumBoldIcon = createIcon(
  Star01MediumBoldIconSvg,
  'Star01MediumBoldIcon',
  20
);
export const Star01LargeIcon = createIcon(
  Star01LargeIconSvg,
  'Star01LargeIcon',
  24
);
export const Star01LargeBoldIcon = createIcon(
  Star01LargeBoldIconSvg,
  'Star01LargeBoldIcon',
  24
);
export const StarFilledXSmallIcon = createIcon(
  StarFilledXSmallIconSvg,
  'StarFilledXSmallIcon',
  12
);
export const StarFilledXSmallBoldIcon = createIcon(
  StarFilledXSmallBoldIconSvg,
  'StarFilledXSmallBoldIcon',
  12
);
export const StarFilledSmallIcon = createIcon(
  StarFilledSmallIconSvg,
  'StarFilledSmallIcon',
  16
);
export const StarFilledSmallBoldIcon = createIcon(
  StarFilledSmallBoldIconSvg,
  'StarFilledSmallBoldIcon',
  16
);
export const StarFilledMediumIcon = createIcon(
  StarFilledMediumIconSvg,
  'StarFilledMediumIcon',
  20
);
export const StarFilledMediumBoldIcon = createIcon(
  StarFilledMediumBoldIconSvg,
  'StarFilledMediumBoldIcon',
  20
);
export const StarFilledLargeIcon = createIcon(
  StarFilledLargeIconSvg,
  'StarFilledLargeIcon',
  24
);
export const StarFilledLargeBoldIcon = createIcon(
  StarFilledLargeBoldIconSvg,
  'StarFilledLargeBoldIcon',
  24
);
export const Edit05XSmallIcon = createIcon(
  Edit05XSmallIconSvg,
  'Edit05XSmallIcon',
  12
);
export const Edit05XSmallBoldIcon = createIcon(
  Edit05XSmallBoldIconSvg,
  'Edit05XSmallBoldIcon',
  12
);
export const Edit05SmallIcon = createIcon(
  Edit05SmallIconSvg,
  'Edit05SmallIcon',
  16
);
export const Edit05SmallBoldIcon = createIcon(
  Edit05SmallBoldIconSvg,
  'Edit05SmallBoldIcon',
  16
);
export const Edit05MediumIcon = createIcon(
  Edit05MediumIconSvg,
  'Edit05MediumIcon',
  20
);
export const Edit05MediumBoldIcon = createIcon(
  Edit05MediumBoldIconSvg,
  'Edit05MediumBoldIcon',
  20
);
export const Edit05LargeIcon = createIcon(
  Edit05LargeIconSvg,
  'Edit05LargeIcon',
  24
);
export const Edit05LargeBoldIcon = createIcon(
  Edit05LargeBoldIconSvg,
  'Edit05LargeBoldIcon',
  24
);
export const EyeXSmallIcon = createIcon(EyeXSmallIconSvg, 'EyeXSmallIcon', 12);
export const EyeXSmallBoldIcon = createIcon(
  EyeXSmallBoldIconSvg,
  'EyeXSmallBoldIcon',
  12
);
export const EyeSmallIcon = createIcon(EyeSmallIconSvg, 'EyeSmallIcon', 16);
export const EyeSmallBoldIcon = createIcon(
  EyeSmallBoldIconSvg,
  'EyeSmallBoldIcon',
  16
);
export const EyeMediumIcon = createIcon(EyeMediumIconSvg, 'EyeMediumIcon', 20);
export const EyeMediumBoldIcon = createIcon(
  EyeMediumBoldIconSvg,
  'EyeMediumBoldIcon',
  20
);
export const EyeLargeIcon = createIcon(EyeLargeIconSvg, 'EyeLargeIcon', 24);
export const EyeLargeBoldIcon = createIcon(
  EyeLargeBoldIconSvg,
  'EyeLargeBoldIcon',
  24
);
export const DotsHorizontalXSmallIcon = createIcon(
  DotsHorizontalXSmallIconSvg,
  'DotsHorizontalXSmallIcon',
  12
);
export const DotsHorizontalXSmallBoldIcon = createIcon(
  DotsHorizontalXSmallBoldIconSvg,
  'DotsHorizontalXSmallBoldIcon',
  12
);
export const DotsHorizontalSmallIcon = createIcon(
  DotsHorizontalSmallIconSvg,
  'DotsHorizontalSmallIcon',
  16
);
export const DotsHorizontalSmallBoldIcon = createIcon(
  DotsHorizontalSmallBoldIconSvg,
  'DotsHorizontalSmallBoldIcon',
  16
);
export const DotsHorizontalMediumIcon = createIcon(
  DotsHorizontalMediumIconSvg,
  'DotsHorizontalMediumIcon',
  20
);
export const DotsHorizontalMediumBoldIcon = createIcon(
  DotsHorizontalMediumBoldIconSvg,
  'DotsHorizontalMediumBoldIcon',
  20
);
export const DotsHorizontalLargeIcon = createIcon(
  DotsHorizontalLargeIconSvg,
  'DotsHorizontalLargeIcon',
  24
);
export const DotsHorizontalLargeBoldIcon = createIcon(
  DotsHorizontalLargeBoldIconSvg,
  'DotsHorizontalLargeBoldIcon',
  24
);
export const DotsVerticalXSmallIcon = createIcon(
  DotsVerticalXSmallIconSvg,
  'DotsVerticalXSmallIcon',
  12
);
export const DotsVerticalXSmallBoldIcon = createIcon(
  DotsVerticalXSmallBoldIconSvg,
  'DotsVerticalXSmallBoldIcon',
  12
);
export const DotsVerticalSmallIcon = createIcon(
  DotsVerticalSmallIconSvg,
  'DotsVerticalSmallIcon',
  16
);
export const DotsVerticalSmallBoldIcon = createIcon(
  DotsVerticalSmallBoldIconSvg,
  'DotsVerticalSmallBoldIcon',
  16
);
export const DotsVerticalMediumIcon = createIcon(
  DotsVerticalMediumIconSvg,
  'DotsVerticalMediumIcon',
  20
);
export const DotsVerticalMediumBoldIcon = createIcon(
  DotsVerticalMediumBoldIconSvg,
  'DotsVerticalMediumBoldIcon',
  20
);
export const DotsVerticalLargeIcon = createIcon(
  DotsVerticalLargeIconSvg,
  'DotsVerticalLargeIcon',
  24
);
export const DotsVerticalLargeBoldIcon = createIcon(
  DotsVerticalLargeBoldIconSvg,
  'DotsVerticalLargeBoldIcon',
  24
);
export const CalendarDateXSmallIcon = createIcon(
  CalendarDateXSmallIconSvg,
  'CalendarDateXSmallIcon',
  12
);
export const CalendarDateXSmallBoldIcon = createIcon(
  CalendarDateXSmallBoldIconSvg,
  'CalendarDateXSmallBoldIcon',
  12
);
export const CalendarDateSmallIcon = createIcon(
  CalendarDateSmallIconSvg,
  'CalendarDateSmallIcon',
  16
);
export const CalendarDateSmallBoldIcon = createIcon(
  CalendarDateSmallBoldIconSvg,
  'CalendarDateSmallBoldIcon',
  16
);
export const CalendarDateMediumIcon = createIcon(
  CalendarDateMediumIconSvg,
  'CalendarDateMediumIcon',
  20
);
export const CalendarDateMediumBoldIcon = createIcon(
  CalendarDateMediumBoldIconSvg,
  'CalendarDateMediumBoldIcon',
  20
);
export const CalendarDateLargeIcon = createIcon(
  CalendarDateLargeIconSvg,
  'CalendarDateLargeIcon',
  24
);
export const CalendarDateLargeBoldIcon = createIcon(
  CalendarDateLargeBoldIconSvg,
  'CalendarDateLargeBoldIcon',
  24
);
export const CalendarCheck01XSmallIcon = createIcon(
  CalendarCheck01XSmallIconSvg,
  'CalendarCheck01XSmallIcon',
  12
);
export const CalendarCheck01XSmallBoldIcon = createIcon(
  CalendarCheck01XSmallBoldIconSvg,
  'CalendarCheck01XSmallBoldIcon',
  12
);
export const CalendarCheck01SmallIcon = createIcon(
  CalendarCheck01SmallIconSvg,
  'CalendarCheck01SmallIcon',
  16
);
export const CalendarCheck01SmallBoldIcon = createIcon(
  CalendarCheck01SmallBoldIconSvg,
  'CalendarCheck01SmallBoldIcon',
  16
);
export const CalendarCheck01MediumIcon = createIcon(
  CalendarCheck01MediumIconSvg,
  'CalendarCheck01MediumIcon',
  20
);
export const CalendarCheck01MediumBoldIcon = createIcon(
  CalendarCheck01MediumBoldIconSvg,
  'CalendarCheck01MediumBoldIcon',
  20
);
export const CalendarCheck01LargeIcon = createIcon(
  CalendarCheck01LargeIconSvg,
  'CalendarCheck01LargeIcon',
  24
);
export const CalendarCheck01LargeBoldIcon = createIcon(
  CalendarCheck01LargeBoldIconSvg,
  'CalendarCheck01LargeBoldIcon',
  24
);
export const CalendarMinus01XSmallIcon = createIcon(
  CalendarMinus01XSmallIconSvg,
  'CalendarMinus01XSmallIcon',
  12
);
export const CalendarMinus01XSmallBoldIcon = createIcon(
  CalendarMinus01XSmallBoldIconSvg,
  'CalendarMinus01XSmallBoldIcon',
  12
);
export const CalendarMinus01SmallIcon = createIcon(
  CalendarMinus01SmallIconSvg,
  'CalendarMinus01SmallIcon',
  16
);
export const CalendarMinus01SmallBoldIcon = createIcon(
  CalendarMinus01SmallBoldIconSvg,
  'CalendarMinus01SmallBoldIcon',
  16
);
export const CalendarMinus01MediumIcon = createIcon(
  CalendarMinus01MediumIconSvg,
  'CalendarMinus01MediumIcon',
  20
);
export const CalendarMinus01MediumBoldIcon = createIcon(
  CalendarMinus01MediumBoldIconSvg,
  'CalendarMinus01MediumBoldIcon',
  20
);
export const CalendarMinus01LargeIcon = createIcon(
  CalendarMinus01LargeIconSvg,
  'CalendarMinus01LargeIcon',
  24
);
export const CalendarMinus01LargeBoldIcon = createIcon(
  CalendarMinus01LargeBoldIconSvg,
  'CalendarMinus01LargeBoldIcon',
  24
);
export const CalendarPlus01XSmallIcon = createIcon(
  CalendarPlus01XSmallIconSvg,
  'CalendarPlus01XSmallIcon',
  12
);
export const CalendarPlus01XSmallBoldIcon = createIcon(
  CalendarPlus01XSmallBoldIconSvg,
  'CalendarPlus01XSmallBoldIcon',
  12
);
export const CalendarPlus01SmallIcon = createIcon(
  CalendarPlus01SmallIconSvg,
  'CalendarPlus01SmallIcon',
  16
);
export const CalendarPlus01SmallBoldIcon = createIcon(
  CalendarPlus01SmallBoldIconSvg,
  'CalendarPlus01SmallBoldIcon',
  16
);
export const CalendarPlus01MediumIcon = createIcon(
  CalendarPlus01MediumIconSvg,
  'CalendarPlus01MediumIcon',
  20
);
export const CalendarPlus01MediumBoldIcon = createIcon(
  CalendarPlus01MediumBoldIconSvg,
  'CalendarPlus01MediumBoldIcon',
  20
);
export const CalendarPlus01LargeIcon = createIcon(
  CalendarPlus01LargeIconSvg,
  'CalendarPlus01LargeIcon',
  24
);
export const CalendarPlus01LargeBoldIcon = createIcon(
  CalendarPlus01LargeBoldIconSvg,
  'CalendarPlus01LargeBoldIcon',
  24
);
export const MessageDotsSquareXSmallIcon = createIcon(
  MessageDotsSquareXSmallIconSvg,
  'MessageDotsSquareXSmallIcon',
  12
);
export const MessageDotsSquareXSmallBoldIcon = createIcon(
  MessageDotsSquareXSmallBoldIconSvg,
  'MessageDotsSquareXSmallBoldIcon',
  12
);
export const MessageDotsSquareSmallIcon = createIcon(
  MessageDotsSquareSmallIconSvg,
  'MessageDotsSquareSmallIcon',
  16
);
export const MessageDotsSquareSmallBoldIcon = createIcon(
  MessageDotsSquareSmallBoldIconSvg,
  'MessageDotsSquareSmallBoldIcon',
  16
);
export const MessageDotsSquareMediumIcon = createIcon(
  MessageDotsSquareMediumIconSvg,
  'MessageDotsSquareMediumIcon',
  20
);
export const MessageDotsSquareMediumBoldIcon = createIcon(
  MessageDotsSquareMediumBoldIconSvg,
  'MessageDotsSquareMediumBoldIcon',
  20
);
export const MessageDotsSquareLargeIcon = createIcon(
  MessageDotsSquareLargeIconSvg,
  'MessageDotsSquareLargeIcon',
  24
);
export const MessageDotsSquareLargeBoldIcon = createIcon(
  MessageDotsSquareLargeBoldIconSvg,
  'MessageDotsSquareLargeBoldIcon',
  24
);
export const CodeSquare01XSmallIcon = createIcon(
  CodeSquare01XSmallIconSvg,
  'CodeSquare01XSmallIcon',
  12
);
export const CodeSquare01XSmallBoldIcon = createIcon(
  CodeSquare01XSmallBoldIconSvg,
  'CodeSquare01XSmallBoldIcon',
  12
);
export const CodeSquare01SmallIcon = createIcon(
  CodeSquare01SmallIconSvg,
  'CodeSquare01SmallIcon',
  16
);
export const CodeSquare01SmallBoldIcon = createIcon(
  CodeSquare01SmallBoldIconSvg,
  'CodeSquare01SmallBoldIcon',
  16
);
export const CodeSquare01MediumIcon = createIcon(
  CodeSquare01MediumIconSvg,
  'CodeSquare01MediumIcon',
  20
);
export const CodeSquare01MediumBoldIcon = createIcon(
  CodeSquare01MediumBoldIconSvg,
  'CodeSquare01MediumBoldIcon',
  20
);
export const CodeSquare01LargeIcon = createIcon(
  CodeSquare01LargeIconSvg,
  'CodeSquare01LargeIcon',
  24
);
export const CodeSquare01LargeBoldIcon = createIcon(
  CodeSquare01LargeBoldIconSvg,
  'CodeSquare01LargeBoldIcon',
  24
);
export const File04XSmallIcon = createIcon(
  File04XSmallIconSvg,
  'File04XSmallIcon',
  12
);
export const File04XSmallBoldIcon = createIcon(
  File04XSmallBoldIconSvg,
  'File04XSmallBoldIcon',
  12
);
export const File04SmallIcon = createIcon(
  File04SmallIconSvg,
  'File04SmallIcon',
  16
);
export const File04SmallBoldIcon = createIcon(
  File04SmallBoldIconSvg,
  'File04SmallBoldIcon',
  16
);
export const File04MediumIcon = createIcon(
  File04MediumIconSvg,
  'File04MediumIcon',
  20
);
export const File04MediumBoldIcon = createIcon(
  File04MediumBoldIconSvg,
  'File04MediumBoldIcon',
  20
);
export const File04LargeIcon = createIcon(
  File04LargeIconSvg,
  'File04LargeIcon',
  24
);
export const File04LargeBoldIcon = createIcon(
  File04LargeBoldIconSvg,
  'File04LargeBoldIcon',
  24
);
export const FileQuestion03XSmallIcon = createIcon(
  FileQuestion03XSmallIconSvg,
  'FileQuestion03XSmallIcon',
  12
);
export const FileQuestion03XSmallBoldIcon = createIcon(
  FileQuestion03XSmallBoldIconSvg,
  'FileQuestion03XSmallBoldIcon',
  12
);
export const FileQuestion03SmallIcon = createIcon(
  FileQuestion03SmallIconSvg,
  'FileQuestion03SmallIcon',
  16
);
export const FileQuestion03SmallBoldIcon = createIcon(
  FileQuestion03SmallBoldIconSvg,
  'FileQuestion03SmallBoldIcon',
  16
);
export const FileQuestion03MediumIcon = createIcon(
  FileQuestion03MediumIconSvg,
  'FileQuestion03MediumIcon',
  20
);
export const FileQuestion03MediumBoldIcon = createIcon(
  FileQuestion03MediumBoldIconSvg,
  'FileQuestion03MediumBoldIcon',
  20
);
export const FileQuestion03LargeIcon = createIcon(
  FileQuestion03LargeIconSvg,
  'FileQuestion03LargeIcon',
  24
);
export const FileQuestion03LargeBoldIcon = createIcon(
  FileQuestion03LargeBoldIconSvg,
  'FileQuestion03LargeBoldIcon',
  24
);
export const Link03XSmallIcon = createIcon(
  Link03XSmallIconSvg,
  'Link03XSmallIcon',
  12
);
export const Link03XSmallBoldIcon = createIcon(
  Link03XSmallBoldIconSvg,
  'Link03XSmallBoldIcon',
  12
);
export const Link03SmallIcon = createIcon(
  Link03SmallIconSvg,
  'Link03SmallIcon',
  16
);
export const Link03SmallBoldIcon = createIcon(
  Link03SmallBoldIconSvg,
  'Link03SmallBoldIcon',
  16
);
export const Link03MediumIcon = createIcon(
  Link03MediumIconSvg,
  'Link03MediumIcon',
  20
);
export const Link03MediumBoldIcon = createIcon(
  Link03MediumBoldIconSvg,
  'Link03MediumBoldIcon',
  20
);
export const Link03LargeIcon = createIcon(
  Link03LargeIconSvg,
  'Link03LargeIcon',
  24
);
export const Link03LargeBoldIcon = createIcon(
  Link03LargeBoldIconSvg,
  'Link03LargeBoldIcon',
  24
);
export const LinkBroken01XSmallIcon = createIcon(
  LinkBroken01XSmallIconSvg,
  'LinkBroken01XSmallIcon',
  12
);
export const LinkBroken01XSmallBoldIcon = createIcon(
  LinkBroken01XSmallBoldIconSvg,
  'LinkBroken01XSmallBoldIcon',
  12
);
export const LinkBroken01SmallIcon = createIcon(
  LinkBroken01SmallIconSvg,
  'LinkBroken01SmallIcon',
  16
);
export const LinkBroken01SmallBoldIcon = createIcon(
  LinkBroken01SmallBoldIconSvg,
  'LinkBroken01SmallBoldIcon',
  16
);
export const LinkBroken01MediumIcon = createIcon(
  LinkBroken01MediumIconSvg,
  'LinkBroken01MediumIcon',
  20
);
export const LinkBroken01MediumBoldIcon = createIcon(
  LinkBroken01MediumBoldIconSvg,
  'LinkBroken01MediumBoldIcon',
  20
);
export const LinkBroken01LargeIcon = createIcon(
  LinkBroken01LargeIconSvg,
  'LinkBroken01LargeIcon',
  24
);
export const LinkBroken01LargeBoldIcon = createIcon(
  LinkBroken01LargeBoldIconSvg,
  'LinkBroken01LargeBoldIcon',
  24
);
export const PauseCircleXSmallIcon = createIcon(
  PauseCircleXSmallIconSvg,
  'PauseCircleXSmallIcon',
  12
);
export const PauseCircleXSmallBoldIcon = createIcon(
  PauseCircleXSmallBoldIconSvg,
  'PauseCircleXSmallBoldIcon',
  12
);
export const PauseCircleSmallIcon = createIcon(
  PauseCircleSmallIconSvg,
  'PauseCircleSmallIcon',
  16
);
export const PauseCircleSmallBoldIcon = createIcon(
  PauseCircleSmallBoldIconSvg,
  'PauseCircleSmallBoldIcon',
  16
);
export const PauseCircleMediumIcon = createIcon(
  PauseCircleMediumIconSvg,
  'PauseCircleMediumIcon',
  20
);
export const PauseCircleMediumBoldIcon = createIcon(
  PauseCircleMediumBoldIconSvg,
  'PauseCircleMediumBoldIcon',
  20
);
export const PauseCircleLargeIcon = createIcon(
  PauseCircleLargeIconSvg,
  'PauseCircleLargeIcon',
  24
);
export const PauseCircleLargeBoldIcon = createIcon(
  PauseCircleLargeBoldIconSvg,
  'PauseCircleLargeBoldIcon',
  24
);
export const ArrowSquareRightXSmallIcon = createIcon(
  ArrowSquareRightXSmallIconSvg,
  'ArrowSquareRightXSmallIcon',
  12
);
export const ArrowSquareRightXSmallBoldIcon = createIcon(
  ArrowSquareRightXSmallBoldIconSvg,
  'ArrowSquareRightXSmallBoldIcon',
  12
);
export const ArrowSquareRightSmallIcon = createIcon(
  ArrowSquareRightSmallIconSvg,
  'ArrowSquareRightSmallIcon',
  16
);
export const ArrowSquareRightSmallBoldIcon = createIcon(
  ArrowSquareRightSmallBoldIconSvg,
  'ArrowSquareRightSmallBoldIcon',
  16
);
export const ArrowSquareRightMediumIcon = createIcon(
  ArrowSquareRightMediumIconSvg,
  'ArrowSquareRightMediumIcon',
  20
);
export const ArrowSquareRightMediumBoldIcon = createIcon(
  ArrowSquareRightMediumBoldIconSvg,
  'ArrowSquareRightMediumBoldIcon',
  20
);
export const ArrowSquareRightLargeIcon = createIcon(
  ArrowSquareRightLargeIconSvg,
  'ArrowSquareRightLargeIcon',
  24
);
export const ArrowSquareRightLargeBoldIcon = createIcon(
  ArrowSquareRightLargeBoldIconSvg,
  'ArrowSquareRightLargeBoldIcon',
  24
);
export const Share07XSmallIcon = createIcon(
  Share07XSmallIconSvg,
  'Share07XSmallIcon',
  12
);
export const Share07XSmallBoldIcon = createIcon(
  Share07XSmallBoldIconSvg,
  'Share07XSmallBoldIcon',
  12
);
export const Share07SmallIcon = createIcon(
  Share07SmallIconSvg,
  'Share07SmallIcon',
  16
);
export const Share07SmallBoldIcon = createIcon(
  Share07SmallBoldIconSvg,
  'Share07SmallBoldIcon',
  16
);
export const Share07MediumIcon = createIcon(
  Share07MediumIconSvg,
  'Share07MediumIcon',
  20
);
export const Share07MediumBoldIcon = createIcon(
  Share07MediumBoldIconSvg,
  'Share07MediumBoldIcon',
  20
);
export const Share07LargeIcon = createIcon(
  Share07LargeIconSvg,
  'Share07LargeIcon',
  24
);
export const Share07LargeBoldIcon = createIcon(
  Share07LargeBoldIconSvg,
  'Share07LargeBoldIcon',
  24
);
export const FilterFunnel01XSmallIcon = createIcon(
  FilterFunnel01XSmallIconSvg,
  'FilterFunnel01XSmallIcon',
  12
);
export const FilterFunnel01XSmallBoldIcon = createIcon(
  FilterFunnel01XSmallBoldIconSvg,
  'FilterFunnel01XSmallBoldIcon',
  12
);
export const FilterFunnel01SmallIcon = createIcon(
  FilterFunnel01SmallIconSvg,
  'FilterFunnel01SmallIcon',
  16
);
export const FilterFunnel01SmallBoldIcon = createIcon(
  FilterFunnel01SmallBoldIconSvg,
  'FilterFunnel01SmallBoldIcon',
  16
);
export const FilterFunnel01MediumIcon = createIcon(
  FilterFunnel01MediumIconSvg,
  'FilterFunnel01MediumIcon',
  20
);
export const FilterFunnel01MediumBoldIcon = createIcon(
  FilterFunnel01MediumBoldIconSvg,
  'FilterFunnel01MediumBoldIcon',
  20
);
export const FilterFunnel01LargeIcon = createIcon(
  FilterFunnel01LargeIconSvg,
  'FilterFunnel01LargeIcon',
  24
);
export const FilterFunnel01LargeBoldIcon = createIcon(
  FilterFunnel01LargeBoldIconSvg,
  'FilterFunnel01LargeBoldIcon',
  24
);
export const Send01XSmallIcon = createIcon(
  Send01XSmallIconSvg,
  'Send01XSmallIcon',
  12
);
export const Send01XSmallBoldIcon = createIcon(
  Send01XSmallBoldIconSvg,
  'Send01XSmallBoldIcon',
  12
);
export const Send01SmallIcon = createIcon(
  Send01SmallIconSvg,
  'Send01SmallIcon',
  16
);
export const Send01SmallBoldIcon = createIcon(
  Send01SmallBoldIconSvg,
  'Send01SmallBoldIcon',
  16
);
export const Send01MediumIcon = createIcon(
  Send01MediumIconSvg,
  'Send01MediumIcon',
  20
);
export const Send01MediumBoldIcon = createIcon(
  Send01MediumBoldIconSvg,
  'Send01MediumBoldIcon',
  20
);
export const Send01LargeIcon = createIcon(
  Send01LargeIconSvg,
  'Send01LargeIcon',
  24
);
export const Send01LargeBoldIcon = createIcon(
  Send01LargeBoldIconSvg,
  'Send01LargeBoldIcon',
  24
);
export const ChevronLeftXSmallIcon = createIcon(
  ChevronLeftXSmallIconSvg,
  'ChevronLeftXSmallIcon',
  12
);
export const ChevronLeftXSmallBoldIcon = createIcon(
  ChevronLeftXSmallBoldIconSvg,
  'ChevronLeftXSmallBoldIcon',
  12
);
export const ChevronLeftSmallIcon = createIcon(
  ChevronLeftSmallIconSvg,
  'ChevronLeftSmallIcon',
  16
);
export const ChevronLeftSmallBoldIcon = createIcon(
  ChevronLeftSmallBoldIconSvg,
  'ChevronLeftSmallBoldIcon',
  16
);
export const ChevronLeftMediumIcon = createIcon(
  ChevronLeftMediumIconSvg,
  'ChevronLeftMediumIcon',
  20
);
export const ChevronLeftMediumBoldIcon = createIcon(
  ChevronLeftMediumBoldIconSvg,
  'ChevronLeftMediumBoldIcon',
  20
);
export const ChevronLeftLargeIcon = createIcon(
  ChevronLeftLargeIconSvg,
  'ChevronLeftLargeIcon',
  24
);
export const ChevronLeftLargeBoldIcon = createIcon(
  ChevronLeftLargeBoldIconSvg,
  'ChevronLeftLargeBoldIcon',
  24
);
export const ChevronRightXSmallIcon = createIcon(
  ChevronRightXSmallIconSvg,
  'ChevronRightXSmallIcon',
  12
);
export const ChevronRightXSmallBoldIcon = createIcon(
  ChevronRightXSmallBoldIconSvg,
  'ChevronRightXSmallBoldIcon',
  12
);
export const ChevronRightSmallIcon = createIcon(
  ChevronRightSmallIconSvg,
  'ChevronRightSmallIcon',
  16
);
export const ChevronRightSmallBoldIcon = createIcon(
  ChevronRightSmallBoldIconSvg,
  'ChevronRightSmallBoldIcon',
  16
);
export const ChevronRightMediumIcon = createIcon(
  ChevronRightMediumIconSvg,
  'ChevronRightMediumIcon',
  20
);
export const ChevronRightMediumBoldIcon = createIcon(
  ChevronRightMediumBoldIconSvg,
  'ChevronRightMediumBoldIcon',
  20
);
export const ChevronRightLargeIcon = createIcon(
  ChevronRightLargeIconSvg,
  'ChevronRightLargeIcon',
  24
);
export const ChevronRightLargeBoldIcon = createIcon(
  ChevronRightLargeBoldIconSvg,
  'ChevronRightLargeBoldIcon',
  24
);
export const ChevronUpXSmallIcon = createIcon(
  ChevronUpXSmallIconSvg,
  'ChevronUpXSmallIcon',
  12
);
export const ChevronUpXSmallBoldIcon = createIcon(
  ChevronUpXSmallBoldIconSvg,
  'ChevronUpXSmallBoldIcon',
  12
);
export const ChevronUpSmallIcon = createIcon(
  ChevronUpSmallIconSvg,
  'ChevronUpSmallIcon',
  16
);
export const ChevronUpSmallBoldIcon = createIcon(
  ChevronUpSmallBoldIconSvg,
  'ChevronUpSmallBoldIcon',
  16
);
export const ChevronUpMediumIcon = createIcon(
  ChevronUpMediumIconSvg,
  'ChevronUpMediumIcon',
  20
);
export const ChevronUpMediumBoldIcon = createIcon(
  ChevronUpMediumBoldIconSvg,
  'ChevronUpMediumBoldIcon',
  20
);
export const ChevronUpLargeIcon = createIcon(
  ChevronUpLargeIconSvg,
  'ChevronUpLargeIcon',
  24
);
export const ChevronUpLargeBoldIcon = createIcon(
  ChevronUpLargeBoldIconSvg,
  'ChevronUpLargeBoldIcon',
  24
);
export const SwitchHorizontal01XSmallIcon = createIcon(
  SwitchHorizontal01XSmallIconSvg,
  'SwitchHorizontal01XSmallIcon',
  12
);
export const SwitchHorizontal01XSmallBoldIcon = createIcon(
  SwitchHorizontal01XSmallBoldIconSvg,
  'SwitchHorizontal01XSmallBoldIcon',
  12
);
export const SwitchHorizontal01SmallIcon = createIcon(
  SwitchHorizontal01SmallIconSvg,
  'SwitchHorizontal01SmallIcon',
  16
);
export const SwitchHorizontal01SmallBoldIcon = createIcon(
  SwitchHorizontal01SmallBoldIconSvg,
  'SwitchHorizontal01SmallBoldIcon',
  16
);
export const SwitchHorizontal01MediumIcon = createIcon(
  SwitchHorizontal01MediumIconSvg,
  'SwitchHorizontal01MediumIcon',
  20
);
export const SwitchHorizontal01MediumBoldIcon = createIcon(
  SwitchHorizontal01MediumBoldIconSvg,
  'SwitchHorizontal01MediumBoldIcon',
  20
);
export const SwitchHorizontal01LargeIcon = createIcon(
  SwitchHorizontal01LargeIconSvg,
  'SwitchHorizontal01LargeIcon',
  24
);
export const SwitchHorizontal01LargeBoldIcon = createIcon(
  SwitchHorizontal01LargeBoldIconSvg,
  'SwitchHorizontal01LargeBoldIcon',
  24
);
export const ArrowSquareDownXSmallIcon = createIcon(
  ArrowSquareDownXSmallIconSvg,
  'ArrowSquareDownXSmallIcon',
  12
);
export const ArrowSquareDownXSmallBoldIcon = createIcon(
  ArrowSquareDownXSmallBoldIconSvg,
  'ArrowSquareDownXSmallBoldIcon',
  12
);
export const ArrowSquareDownSmallIcon = createIcon(
  ArrowSquareDownSmallIconSvg,
  'ArrowSquareDownSmallIcon',
  16
);
export const ArrowSquareDownSmallBoldIcon = createIcon(
  ArrowSquareDownSmallBoldIconSvg,
  'ArrowSquareDownSmallBoldIcon',
  16
);
export const ArrowSquareDownMediumIcon = createIcon(
  ArrowSquareDownMediumIconSvg,
  'ArrowSquareDownMediumIcon',
  20
);
export const ArrowSquareDownMediumBoldIcon = createIcon(
  ArrowSquareDownMediumBoldIconSvg,
  'ArrowSquareDownMediumBoldIcon',
  20
);
export const ArrowSquareDownLargeIcon = createIcon(
  ArrowSquareDownLargeIconSvg,
  'ArrowSquareDownLargeIcon',
  24
);
export const ArrowSquareDownLargeBoldIcon = createIcon(
  ArrowSquareDownLargeBoldIconSvg,
  'ArrowSquareDownLargeBoldIcon',
  24
);
export const ArrowSquareLeftXSmallIcon = createIcon(
  ArrowSquareLeftXSmallIconSvg,
  'ArrowSquareLeftXSmallIcon',
  12
);
export const ArrowSquareLeftXSmallBoldIcon = createIcon(
  ArrowSquareLeftXSmallBoldIconSvg,
  'ArrowSquareLeftXSmallBoldIcon',
  12
);
export const ArrowSquareLeftSmallIcon = createIcon(
  ArrowSquareLeftSmallIconSvg,
  'ArrowSquareLeftSmallIcon',
  16
);
export const ArrowSquareLeftSmallBoldIcon = createIcon(
  ArrowSquareLeftSmallBoldIconSvg,
  'ArrowSquareLeftSmallBoldIcon',
  16
);
export const ArrowSquareLeftMediumIcon = createIcon(
  ArrowSquareLeftMediumIconSvg,
  'ArrowSquareLeftMediumIcon',
  20
);
export const ArrowSquareLeftMediumBoldIcon = createIcon(
  ArrowSquareLeftMediumBoldIconSvg,
  'ArrowSquareLeftMediumBoldIcon',
  20
);
export const ArrowSquareLeftLargeIcon = createIcon(
  ArrowSquareLeftLargeIconSvg,
  'ArrowSquareLeftLargeIcon',
  24
);
export const ArrowSquareLeftLargeBoldIcon = createIcon(
  ArrowSquareLeftLargeBoldIconSvg,
  'ArrowSquareLeftLargeBoldIcon',
  24
);
export const PlayCircleXSmallIcon = createIcon(
  PlayCircleXSmallIconSvg,
  'PlayCircleXSmallIcon',
  12
);
export const PlayCircleXSmallBoldIcon = createIcon(
  PlayCircleXSmallBoldIconSvg,
  'PlayCircleXSmallBoldIcon',
  12
);
export const PlayCircleSmallIcon = createIcon(
  PlayCircleSmallIconSvg,
  'PlayCircleSmallIcon',
  16
);
export const PlayCircleSmallBoldIcon = createIcon(
  PlayCircleSmallBoldIconSvg,
  'PlayCircleSmallBoldIcon',
  16
);
export const PlayCircleMediumIcon = createIcon(
  PlayCircleMediumIconSvg,
  'PlayCircleMediumIcon',
  20
);
export const PlayCircleMediumBoldIcon = createIcon(
  PlayCircleMediumBoldIconSvg,
  'PlayCircleMediumBoldIcon',
  20
);
export const PlayCircleLargeIcon = createIcon(
  PlayCircleLargeIconSvg,
  'PlayCircleLargeIcon',
  24
);
export const PlayCircleLargeBoldIcon = createIcon(
  PlayCircleLargeBoldIconSvg,
  'PlayCircleLargeBoldIcon',
  24
);
export const ArrowSquareUpXSmallIcon = createIcon(
  ArrowSquareUpXSmallIconSvg,
  'ArrowSquareUpXSmallIcon',
  12
);
export const ArrowSquareUpXSmallBoldIcon = createIcon(
  ArrowSquareUpXSmallBoldIconSvg,
  'ArrowSquareUpXSmallBoldIcon',
  12
);
export const ArrowSquareUpSmallIcon = createIcon(
  ArrowSquareUpSmallIconSvg,
  'ArrowSquareUpSmallIcon',
  16
);
export const ArrowSquareUpSmallBoldIcon = createIcon(
  ArrowSquareUpSmallBoldIconSvg,
  'ArrowSquareUpSmallBoldIcon',
  16
);
export const ArrowSquareUpMediumIcon = createIcon(
  ArrowSquareUpMediumIconSvg,
  'ArrowSquareUpMediumIcon',
  20
);
export const ArrowSquareUpMediumBoldIcon = createIcon(
  ArrowSquareUpMediumBoldIconSvg,
  'ArrowSquareUpMediumBoldIcon',
  20
);
export const ArrowSquareUpLargeIcon = createIcon(
  ArrowSquareUpLargeIconSvg,
  'ArrowSquareUpLargeIcon',
  24
);
export const ArrowSquareUpLargeBoldIcon = createIcon(
  ArrowSquareUpLargeBoldIconSvg,
  'ArrowSquareUpLargeBoldIcon',
  24
);
export const LinkExternal02XSmallIcon = createIcon(
  LinkExternal02XSmallIconSvg,
  'LinkExternal02XSmallIcon',
  12
);
export const LinkExternal02XSmallBoldIcon = createIcon(
  LinkExternal02XSmallBoldIconSvg,
  'LinkExternal02XSmallBoldIcon',
  12
);
export const LinkExternal02SmallIcon = createIcon(
  LinkExternal02SmallIconSvg,
  'LinkExternal02SmallIcon',
  16
);
export const LinkExternal02SmallBoldIcon = createIcon(
  LinkExternal02SmallBoldIconSvg,
  'LinkExternal02SmallBoldIcon',
  16
);
export const LinkExternal02MediumIcon = createIcon(
  LinkExternal02MediumIconSvg,
  'LinkExternal02MediumIcon',
  20
);
export const LinkExternal02MediumBoldIcon = createIcon(
  LinkExternal02MediumBoldIconSvg,
  'LinkExternal02MediumBoldIcon',
  20
);
export const LinkExternal02LargeIcon = createIcon(
  LinkExternal02LargeIconSvg,
  'LinkExternal02LargeIcon',
  24
);
export const LinkExternal02LargeBoldIcon = createIcon(
  LinkExternal02LargeBoldIconSvg,
  'LinkExternal02LargeBoldIcon',
  24
);
export const ArrowSquareDownRightXSmallIcon = createIcon(
  ArrowSquareDownRightXSmallIconSvg,
  'ArrowSquareDownRightXSmallIcon',
  12
);
export const ArrowSquareDownRightXSmallBoldIcon = createIcon(
  ArrowSquareDownRightXSmallBoldIconSvg,
  'ArrowSquareDownRightXSmallBoldIcon',
  12
);
export const ArrowSquareDownRightSmallIcon = createIcon(
  ArrowSquareDownRightSmallIconSvg,
  'ArrowSquareDownRightSmallIcon',
  16
);
export const ArrowSquareDownRightSmallBoldIcon = createIcon(
  ArrowSquareDownRightSmallBoldIconSvg,
  'ArrowSquareDownRightSmallBoldIcon',
  16
);
export const ArrowSquareDownRightMediumIcon = createIcon(
  ArrowSquareDownRightMediumIconSvg,
  'ArrowSquareDownRightMediumIcon',
  20
);
export const ArrowSquareDownRightMediumBoldIcon = createIcon(
  ArrowSquareDownRightMediumBoldIconSvg,
  'ArrowSquareDownRightMediumBoldIcon',
  20
);
export const ArrowSquareDownRightLargeIcon = createIcon(
  ArrowSquareDownRightLargeIconSvg,
  'ArrowSquareDownRightLargeIcon',
  24
);
export const ArrowSquareDownRightLargeBoldIcon = createIcon(
  ArrowSquareDownRightLargeBoldIconSvg,
  'ArrowSquareDownRightLargeBoldIcon',
  24
);
export const ArrowSquareUpLeftXSmallIcon = createIcon(
  ArrowSquareUpLeftXSmallIconSvg,
  'ArrowSquareUpLeftXSmallIcon',
  12
);
export const ArrowSquareUpLeftXSmallBoldIcon = createIcon(
  ArrowSquareUpLeftXSmallBoldIconSvg,
  'ArrowSquareUpLeftXSmallBoldIcon',
  12
);
export const ArrowSquareUpLeftSmallIcon = createIcon(
  ArrowSquareUpLeftSmallIconSvg,
  'ArrowSquareUpLeftSmallIcon',
  16
);
export const ArrowSquareUpLeftSmallBoldIcon = createIcon(
  ArrowSquareUpLeftSmallBoldIconSvg,
  'ArrowSquareUpLeftSmallBoldIcon',
  16
);
export const ArrowSquareUpLeftMediumIcon = createIcon(
  ArrowSquareUpLeftMediumIconSvg,
  'ArrowSquareUpLeftMediumIcon',
  20
);
export const ArrowSquareUpLeftMediumBoldIcon = createIcon(
  ArrowSquareUpLeftMediumBoldIconSvg,
  'ArrowSquareUpLeftMediumBoldIcon',
  20
);
export const ArrowSquareUpLeftLargeIcon = createIcon(
  ArrowSquareUpLeftLargeIconSvg,
  'ArrowSquareUpLeftLargeIcon',
  24
);
export const ArrowSquareUpLeftLargeBoldIcon = createIcon(
  ArrowSquareUpLeftLargeBoldIconSvg,
  'ArrowSquareUpLeftLargeBoldIcon',
  24
);
export const ArrowSquareUpRightXSmallIcon = createIcon(
  ArrowSquareUpRightXSmallIconSvg,
  'ArrowSquareUpRightXSmallIcon',
  12
);
export const ArrowSquareUpRightXSmallBoldIcon = createIcon(
  ArrowSquareUpRightXSmallBoldIconSvg,
  'ArrowSquareUpRightXSmallBoldIcon',
  12
);
export const ArrowSquareUpRightSmallIcon = createIcon(
  ArrowSquareUpRightSmallIconSvg,
  'ArrowSquareUpRightSmallIcon',
  16
);
export const ArrowSquareUpRightSmallBoldIcon = createIcon(
  ArrowSquareUpRightSmallBoldIconSvg,
  'ArrowSquareUpRightSmallBoldIcon',
  16
);
export const ArrowSquareUpRightMediumIcon = createIcon(
  ArrowSquareUpRightMediumIconSvg,
  'ArrowSquareUpRightMediumIcon',
  20
);
export const ArrowSquareUpRightMediumBoldIcon = createIcon(
  ArrowSquareUpRightMediumBoldIconSvg,
  'ArrowSquareUpRightMediumBoldIcon',
  20
);
export const ArrowSquareUpRightLargeIcon = createIcon(
  ArrowSquareUpRightLargeIconSvg,
  'ArrowSquareUpRightLargeIcon',
  24
);
export const ArrowSquareUpRightLargeBoldIcon = createIcon(
  ArrowSquareUpRightLargeBoldIconSvg,
  'ArrowSquareUpRightLargeBoldIcon',
  24
);
export const ArrowLeftXSmallIcon = createIcon(
  ArrowLeftXSmallIconSvg,
  'ArrowLeftXSmallIcon',
  12
);
export const ArrowLeftXSmallBoldIcon = createIcon(
  ArrowLeftXSmallBoldIconSvg,
  'ArrowLeftXSmallBoldIcon',
  12
);
export const ArrowLeftSmallIcon = createIcon(
  ArrowLeftSmallIconSvg,
  'ArrowLeftSmallIcon',
  16
);
export const ArrowLeftSmallBoldIcon = createIcon(
  ArrowLeftSmallBoldIconSvg,
  'ArrowLeftSmallBoldIcon',
  16
);
export const ArrowLeftMediumIcon = createIcon(
  ArrowLeftMediumIconSvg,
  'ArrowLeftMediumIcon',
  20
);
export const ArrowLeftMediumBoldIcon = createIcon(
  ArrowLeftMediumBoldIconSvg,
  'ArrowLeftMediumBoldIcon',
  20
);
export const ArrowLeftLargeIcon = createIcon(
  ArrowLeftLargeIconSvg,
  'ArrowLeftLargeIcon',
  24
);
export const ArrowLeftLargeBoldIcon = createIcon(
  ArrowLeftLargeBoldIconSvg,
  'ArrowLeftLargeBoldIcon',
  24
);
export const ArrowRightXSmallIcon = createIcon(
  ArrowRightXSmallIconSvg,
  'ArrowRightXSmallIcon',
  12
);
export const ArrowRightXSmallBoldIcon = createIcon(
  ArrowRightXSmallBoldIconSvg,
  'ArrowRightXSmallBoldIcon',
  12
);
export const ArrowRightSmallIcon = createIcon(
  ArrowRightSmallIconSvg,
  'ArrowRightSmallIcon',
  16
);
export const ArrowRightSmallBoldIcon = createIcon(
  ArrowRightSmallBoldIconSvg,
  'ArrowRightSmallBoldIcon',
  16
);
export const ArrowRightMediumIcon = createIcon(
  ArrowRightMediumIconSvg,
  'ArrowRightMediumIcon',
  20
);
export const ArrowRightMediumBoldIcon = createIcon(
  ArrowRightMediumBoldIconSvg,
  'ArrowRightMediumBoldIcon',
  20
);
export const ArrowRightLargeIcon = createIcon(
  ArrowRightLargeIconSvg,
  'ArrowRightLargeIcon',
  24
);
export const ArrowRightLargeBoldIcon = createIcon(
  ArrowRightLargeBoldIconSvg,
  'ArrowRightLargeBoldIcon',
  24
);
export const ArrowUpXSmallIcon = createIcon(
  ArrowUpXSmallIconSvg,
  'ArrowUpXSmallIcon',
  12
);
export const ArrowUpXSmallBoldIcon = createIcon(
  ArrowUpXSmallBoldIconSvg,
  'ArrowUpXSmallBoldIcon',
  12
);
export const ArrowUpSmallIcon = createIcon(
  ArrowUpSmallIconSvg,
  'ArrowUpSmallIcon',
  16
);
export const ArrowUpSmallBoldIcon = createIcon(
  ArrowUpSmallBoldIconSvg,
  'ArrowUpSmallBoldIcon',
  16
);
export const ArrowUpMediumIcon = createIcon(
  ArrowUpMediumIconSvg,
  'ArrowUpMediumIcon',
  20
);
export const ArrowUpMediumBoldIcon = createIcon(
  ArrowUpMediumBoldIconSvg,
  'ArrowUpMediumBoldIcon',
  20
);
export const ArrowUpLargeIcon = createIcon(
  ArrowUpLargeIconSvg,
  'ArrowUpLargeIcon',
  24
);
export const ArrowUpLargeBoldIcon = createIcon(
  ArrowUpLargeBoldIconSvg,
  'ArrowUpLargeBoldIcon',
  24
);
export const ArrowUpLeftXSmallIcon = createIcon(
  ArrowUpLeftXSmallIconSvg,
  'ArrowUpLeftXSmallIcon',
  12
);
export const ArrowUpLeftXSmallBoldIcon = createIcon(
  ArrowUpLeftXSmallBoldIconSvg,
  'ArrowUpLeftXSmallBoldIcon',
  12
);
export const ArrowUpLeftSmallIcon = createIcon(
  ArrowUpLeftSmallIconSvg,
  'ArrowUpLeftSmallIcon',
  16
);
export const ArrowUpLeftSmallBoldIcon = createIcon(
  ArrowUpLeftSmallBoldIconSvg,
  'ArrowUpLeftSmallBoldIcon',
  16
);
export const ArrowUpLeftMediumIcon = createIcon(
  ArrowUpLeftMediumIconSvg,
  'ArrowUpLeftMediumIcon',
  20
);
export const ArrowUpLeftMediumBoldIcon = createIcon(
  ArrowUpLeftMediumBoldIconSvg,
  'ArrowUpLeftMediumBoldIcon',
  20
);
export const ArrowUpLeftLargeIcon = createIcon(
  ArrowUpLeftLargeIconSvg,
  'ArrowUpLeftLargeIcon',
  24
);
export const ArrowUpLeftLargeBoldIcon = createIcon(
  ArrowUpLeftLargeBoldIconSvg,
  'ArrowUpLeftLargeBoldIcon',
  24
);
export const ArrowUpRightXSmallIcon = createIcon(
  ArrowUpRightXSmallIconSvg,
  'ArrowUpRightXSmallIcon',
  12
);
export const ArrowUpRightXSmallBoldIcon = createIcon(
  ArrowUpRightXSmallBoldIconSvg,
  'ArrowUpRightXSmallBoldIcon',
  12
);
export const ArrowUpRightSmallIcon = createIcon(
  ArrowUpRightSmallIconSvg,
  'ArrowUpRightSmallIcon',
  16
);
export const ArrowUpRightSmallBoldIcon = createIcon(
  ArrowUpRightSmallBoldIconSvg,
  'ArrowUpRightSmallBoldIcon',
  16
);
export const ArrowUpRightMediumIcon = createIcon(
  ArrowUpRightMediumIconSvg,
  'ArrowUpRightMediumIcon',
  20
);
export const ArrowUpRightMediumBoldIcon = createIcon(
  ArrowUpRightMediumBoldIconSvg,
  'ArrowUpRightMediumBoldIcon',
  20
);
export const ArrowUpRightLargeIcon = createIcon(
  ArrowUpRightLargeIconSvg,
  'ArrowUpRightLargeIcon',
  24
);
export const ArrowUpRightLargeBoldIcon = createIcon(
  ArrowUpRightLargeBoldIconSvg,
  'ArrowUpRightLargeBoldIcon',
  24
);
export const ArrowSquareDownLeftXSmallIcon = createIcon(
  ArrowSquareDownLeftXSmallIconSvg,
  'ArrowSquareDownLeftXSmallIcon',
  12
);
export const ArrowSquareDownLeftXSmallBoldIcon = createIcon(
  ArrowSquareDownLeftXSmallBoldIconSvg,
  'ArrowSquareDownLeftXSmallBoldIcon',
  12
);
export const ArrowSquareDownLeftSmallIcon = createIcon(
  ArrowSquareDownLeftSmallIconSvg,
  'ArrowSquareDownLeftSmallIcon',
  16
);
export const ArrowSquareDownLeftSmallBoldIcon = createIcon(
  ArrowSquareDownLeftSmallBoldIconSvg,
  'ArrowSquareDownLeftSmallBoldIcon',
  16
);
export const ArrowSquareDownLeftMediumIcon = createIcon(
  ArrowSquareDownLeftMediumIconSvg,
  'ArrowSquareDownLeftMediumIcon',
  20
);
export const ArrowSquareDownLeftMediumBoldIcon = createIcon(
  ArrowSquareDownLeftMediumBoldIconSvg,
  'ArrowSquareDownLeftMediumBoldIcon',
  20
);
export const ArrowSquareDownLeftLargeIcon = createIcon(
  ArrowSquareDownLeftLargeIconSvg,
  'ArrowSquareDownLeftLargeIcon',
  24
);
export const ArrowSquareDownLeftLargeBoldIcon = createIcon(
  ArrowSquareDownLeftLargeBoldIconSvg,
  'ArrowSquareDownLeftLargeBoldIcon',
  24
);
export const ArrowDownXSmallIcon = createIcon(
  ArrowDownXSmallIconSvg,
  'ArrowDownXSmallIcon',
  12
);
export const ArrowDownXSmallBoldIcon = createIcon(
  ArrowDownXSmallBoldIconSvg,
  'ArrowDownXSmallBoldIcon',
  12
);
export const ArrowDownSmallIcon = createIcon(
  ArrowDownSmallIconSvg,
  'ArrowDownSmallIcon',
  16
);
export const ArrowDownSmallBoldIcon = createIcon(
  ArrowDownSmallBoldIconSvg,
  'ArrowDownSmallBoldIcon',
  16
);
export const ArrowDownMediumIcon = createIcon(
  ArrowDownMediumIconSvg,
  'ArrowDownMediumIcon',
  20
);
export const ArrowDownMediumBoldIcon = createIcon(
  ArrowDownMediumBoldIconSvg,
  'ArrowDownMediumBoldIcon',
  20
);
export const ArrowDownLargeIcon = createIcon(
  ArrowDownLargeIconSvg,
  'ArrowDownLargeIcon',
  24
);
export const ArrowDownLargeBoldIcon = createIcon(
  ArrowDownLargeBoldIconSvg,
  'ArrowDownLargeBoldIcon',
  24
);
export const ArrowDownLeftXSmallIcon = createIcon(
  ArrowDownLeftXSmallIconSvg,
  'ArrowDownLeftXSmallIcon',
  12
);
export const ArrowDownLeftXSmallBoldIcon = createIcon(
  ArrowDownLeftXSmallBoldIconSvg,
  'ArrowDownLeftXSmallBoldIcon',
  12
);
export const ArrowDownLeftSmallIcon = createIcon(
  ArrowDownLeftSmallIconSvg,
  'ArrowDownLeftSmallIcon',
  16
);
export const ArrowDownLeftSmallBoldIcon = createIcon(
  ArrowDownLeftSmallBoldIconSvg,
  'ArrowDownLeftSmallBoldIcon',
  16
);
export const ArrowDownLeftMediumIcon = createIcon(
  ArrowDownLeftMediumIconSvg,
  'ArrowDownLeftMediumIcon',
  20
);
export const ArrowDownLeftMediumBoldIcon = createIcon(
  ArrowDownLeftMediumBoldIconSvg,
  'ArrowDownLeftMediumBoldIcon',
  20
);
export const ArrowDownLeftLargeIcon = createIcon(
  ArrowDownLeftLargeIconSvg,
  'ArrowDownLeftLargeIcon',
  24
);
export const ArrowDownLeftLargeBoldIcon = createIcon(
  ArrowDownLeftLargeBoldIconSvg,
  'ArrowDownLeftLargeBoldIcon',
  24
);
export const ArrowDownRightXSmallIcon = createIcon(
  ArrowDownRightXSmallIconSvg,
  'ArrowDownRightXSmallIcon',
  12
);
export const ArrowDownRightXSmallBoldIcon = createIcon(
  ArrowDownRightXSmallBoldIconSvg,
  'ArrowDownRightXSmallBoldIcon',
  12
);
export const ArrowDownRightSmallIcon = createIcon(
  ArrowDownRightSmallIconSvg,
  'ArrowDownRightSmallIcon',
  16
);
export const ArrowDownRightSmallBoldIcon = createIcon(
  ArrowDownRightSmallBoldIconSvg,
  'ArrowDownRightSmallBoldIcon',
  16
);
export const ArrowDownRightMediumIcon = createIcon(
  ArrowDownRightMediumIconSvg,
  'ArrowDownRightMediumIcon',
  20
);
export const ArrowDownRightMediumBoldIcon = createIcon(
  ArrowDownRightMediumBoldIconSvg,
  'ArrowDownRightMediumBoldIcon',
  20
);
export const ArrowDownRightLargeIcon = createIcon(
  ArrowDownRightLargeIconSvg,
  'ArrowDownRightLargeIcon',
  24
);
export const ArrowDownRightLargeBoldIcon = createIcon(
  ArrowDownRightLargeBoldIconSvg,
  'ArrowDownRightLargeBoldIcon',
  24
);
export const CheckCircleXSmallIcon = createIcon(
  CheckCircleXSmallIconSvg,
  'CheckCircleXSmallIcon',
  12
);
export const CheckCircleXSmallBoldIcon = createIcon(
  CheckCircleXSmallBoldIconSvg,
  'CheckCircleXSmallBoldIcon',
  12
);
export const CheckCircleSmallIcon = createIcon(
  CheckCircleSmallIconSvg,
  'CheckCircleSmallIcon',
  16
);
export const CheckCircleSmallBoldIcon = createIcon(
  CheckCircleSmallBoldIconSvg,
  'CheckCircleSmallBoldIcon',
  16
);
export const CheckCircleMediumIcon = createIcon(
  CheckCircleMediumIconSvg,
  'CheckCircleMediumIcon',
  20
);
export const CheckCircleMediumBoldIcon = createIcon(
  CheckCircleMediumBoldIconSvg,
  'CheckCircleMediumBoldIcon',
  20
);
export const CheckCircleLargeIcon = createIcon(
  CheckCircleLargeIconSvg,
  'CheckCircleLargeIcon',
  24
);
export const CheckCircleLargeBoldIcon = createIcon(
  CheckCircleLargeBoldIconSvg,
  'CheckCircleLargeBoldIcon',
  24
);
export const Download01XSmallIcon = createIcon(
  Download01XSmallIconSvg,
  'Download01XSmallIcon',
  12
);
export const Download01XSmallBoldIcon = createIcon(
  Download01XSmallBoldIconSvg,
  'Download01XSmallBoldIcon',
  12
);
export const Download01SmallIcon = createIcon(
  Download01SmallIconSvg,
  'Download01SmallIcon',
  16
);
export const Download01SmallBoldIcon = createIcon(
  Download01SmallBoldIconSvg,
  'Download01SmallBoldIcon',
  16
);
export const Download01MediumIcon = createIcon(
  Download01MediumIconSvg,
  'Download01MediumIcon',
  20
);
export const Download01MediumBoldIcon = createIcon(
  Download01MediumBoldIconSvg,
  'Download01MediumBoldIcon',
  20
);
export const Download01LargeIcon = createIcon(
  Download01LargeIconSvg,
  'Download01LargeIcon',
  24
);
export const Download01LargeBoldIcon = createIcon(
  Download01LargeBoldIconSvg,
  'Download01LargeBoldIcon',
  24
);
export const CheckXSmallIcon = createIcon(
  CheckXSmallIconSvg,
  'CheckXSmallIcon',
  12
);
export const CheckXSmallBoldIcon = createIcon(
  CheckXSmallBoldIconSvg,
  'CheckXSmallBoldIcon',
  12
);
export const CheckSmallIcon = createIcon(
  CheckSmallIconSvg,
  'CheckSmallIcon',
  16
);
export const CheckSmallBoldIcon = createIcon(
  CheckSmallBoldIconSvg,
  'CheckSmallBoldIcon',
  16
);
export const CheckMediumIcon = createIcon(
  CheckMediumIconSvg,
  'CheckMediumIcon',
  20
);
export const CheckMediumBoldIcon = createIcon(
  CheckMediumBoldIconSvg,
  'CheckMediumBoldIcon',
  20
);
export const CheckLargeIcon = createIcon(
  CheckLargeIconSvg,
  'CheckLargeIcon',
  24
);
export const CheckLargeBoldIcon = createIcon(
  CheckLargeBoldIconSvg,
  'CheckLargeBoldIcon',
  24
);
export const RefreshCcw02XSmallIcon = createIcon(
  RefreshCcw02XSmallIconSvg,
  'RefreshCcw02XSmallIcon',
  12
);
export const RefreshCcw02XSmallBoldIcon = createIcon(
  RefreshCcw02XSmallBoldIconSvg,
  'RefreshCcw02XSmallBoldIcon',
  12
);
export const RefreshCcw02SmallIcon = createIcon(
  RefreshCcw02SmallIconSvg,
  'RefreshCcw02SmallIcon',
  16
);
export const RefreshCcw02SmallBoldIcon = createIcon(
  RefreshCcw02SmallBoldIconSvg,
  'RefreshCcw02SmallBoldIcon',
  16
);
export const RefreshCcw02MediumIcon = createIcon(
  RefreshCcw02MediumIconSvg,
  'RefreshCcw02MediumIcon',
  20
);
export const RefreshCcw02MediumBoldIcon = createIcon(
  RefreshCcw02MediumBoldIconSvg,
  'RefreshCcw02MediumBoldIcon',
  20
);
export const RefreshCcw02LargeIcon = createIcon(
  RefreshCcw02LargeIconSvg,
  'RefreshCcw02LargeIcon',
  24
);
export const RefreshCcw02LargeBoldIcon = createIcon(
  RefreshCcw02LargeBoldIconSvg,
  'RefreshCcw02LargeBoldIcon',
  24
);
export const RefreshCcw01XSmallIcon = createIcon(
  RefreshCcw01XSmallIconSvg,
  'RefreshCcw01XSmallIcon',
  12
);
export const RefreshCcw01XSmallBoldIcon = createIcon(
  RefreshCcw01XSmallBoldIconSvg,
  'RefreshCcw01XSmallBoldIcon',
  12
);
export const RefreshCcw01SmallIcon = createIcon(
  RefreshCcw01SmallIconSvg,
  'RefreshCcw01SmallIcon',
  16
);
export const RefreshCcw01SmallBoldIcon = createIcon(
  RefreshCcw01SmallBoldIconSvg,
  'RefreshCcw01SmallBoldIcon',
  16
);
export const RefreshCcw01MediumIcon = createIcon(
  RefreshCcw01MediumIconSvg,
  'RefreshCcw01MediumIcon',
  20
);
export const RefreshCcw01MediumBoldIcon = createIcon(
  RefreshCcw01MediumBoldIconSvg,
  'RefreshCcw01MediumBoldIcon',
  20
);
export const RefreshCcw01LargeIcon = createIcon(
  RefreshCcw01LargeIconSvg,
  'RefreshCcw01LargeIcon',
  24
);
export const RefreshCcw01LargeBoldIcon = createIcon(
  RefreshCcw01LargeBoldIconSvg,
  'RefreshCcw01LargeBoldIcon',
  24
);
export const LogOut01XSmallIcon = createIcon(
  LogOut01XSmallIconSvg,
  'LogOut01XSmallIcon',
  12
);
export const LogOut01XSmallBoldIcon = createIcon(
  LogOut01XSmallBoldIconSvg,
  'LogOut01XSmallBoldIcon',
  12
);
export const LogOut01SmallIcon = createIcon(
  LogOut01SmallIconSvg,
  'LogOut01SmallIcon',
  16
);
export const LogOut01SmallBoldIcon = createIcon(
  LogOut01SmallBoldIconSvg,
  'LogOut01SmallBoldIcon',
  16
);
export const LogOut01MediumIcon = createIcon(
  LogOut01MediumIconSvg,
  'LogOut01MediumIcon',
  20
);
export const LogOut01MediumBoldIcon = createIcon(
  LogOut01MediumBoldIconSvg,
  'LogOut01MediumBoldIcon',
  20
);
export const LogOut01LargeIcon = createIcon(
  LogOut01LargeIconSvg,
  'LogOut01LargeIcon',
  24
);
export const LogOut01LargeBoldIcon = createIcon(
  LogOut01LargeBoldIconSvg,
  'LogOut01LargeBoldIcon',
  24
);
export const Expand01XSmallIcon = createIcon(
  Expand01XSmallIconSvg,
  'Expand01XSmallIcon',
  12
);
export const Expand01XSmallBoldIcon = createIcon(
  Expand01XSmallBoldIconSvg,
  'Expand01XSmallBoldIcon',
  12
);
export const Expand01SmallIcon = createIcon(
  Expand01SmallIconSvg,
  'Expand01SmallIcon',
  16
);
export const Expand01SmallBoldIcon = createIcon(
  Expand01SmallBoldIconSvg,
  'Expand01SmallBoldIcon',
  16
);
export const Expand01MediumIcon = createIcon(
  Expand01MediumIconSvg,
  'Expand01MediumIcon',
  20
);
export const Expand01MediumBoldIcon = createIcon(
  Expand01MediumBoldIconSvg,
  'Expand01MediumBoldIcon',
  20
);
export const Expand01LargeIcon = createIcon(
  Expand01LargeIconSvg,
  'Expand01LargeIcon',
  24
);
export const Expand01LargeBoldIcon = createIcon(
  Expand01LargeBoldIconSvg,
  'Expand01LargeBoldIcon',
  24
);
export const LogIn01XSmallIcon = createIcon(
  LogIn01XSmallIconSvg,
  'LogIn01XSmallIcon',
  12
);
export const LogIn01XSmallBoldIcon = createIcon(
  LogIn01XSmallBoldIconSvg,
  'LogIn01XSmallBoldIcon',
  12
);
export const LogIn01SmallIcon = createIcon(
  LogIn01SmallIconSvg,
  'LogIn01SmallIcon',
  16
);
export const LogIn01SmallBoldIcon = createIcon(
  LogIn01SmallBoldIconSvg,
  'LogIn01SmallBoldIcon',
  16
);
export const LogIn01MediumIcon = createIcon(
  LogIn01MediumIconSvg,
  'LogIn01MediumIcon',
  20
);
export const LogIn01MediumBoldIcon = createIcon(
  LogIn01MediumBoldIconSvg,
  'LogIn01MediumBoldIcon',
  20
);
export const LogIn01LargeIcon = createIcon(
  LogIn01LargeIconSvg,
  'LogIn01LargeIcon',
  24
);
export const LogIn01LargeBoldIcon = createIcon(
  LogIn01LargeBoldIconSvg,
  'LogIn01LargeBoldIcon',
  24
);
export const Share02XSmallIcon = createIcon(
  Share02XSmallIconSvg,
  'Share02XSmallIcon',
  12
);
export const Share02XSmallBoldIcon = createIcon(
  Share02XSmallBoldIconSvg,
  'Share02XSmallBoldIcon',
  12
);
export const Share02SmallIcon = createIcon(
  Share02SmallIconSvg,
  'Share02SmallIcon',
  16
);
export const Share02SmallBoldIcon = createIcon(
  Share02SmallBoldIconSvg,
  'Share02SmallBoldIcon',
  16
);
export const Share02MediumIcon = createIcon(
  Share02MediumIconSvg,
  'Share02MediumIcon',
  20
);
export const Share02MediumBoldIcon = createIcon(
  Share02MediumBoldIconSvg,
  'Share02MediumBoldIcon',
  20
);
export const Share02LargeIcon = createIcon(
  Share02LargeIconSvg,
  'Share02LargeIcon',
  24
);
export const Share02LargeBoldIcon = createIcon(
  Share02LargeBoldIconSvg,
  'Share02LargeBoldIcon',
  24
);
export const XCloseXSmallIcon = createIcon(
  XCloseXSmallIconSvg,
  'XCloseXSmallIcon',
  12
);
export const XCloseXSmallBoldIcon = createIcon(
  XCloseXSmallBoldIconSvg,
  'XCloseXSmallBoldIcon',
  12
);
export const XCloseSmallIcon = createIcon(
  XCloseSmallIconSvg,
  'XCloseSmallIcon',
  16
);
export const XCloseSmallBoldIcon = createIcon(
  XCloseSmallBoldIconSvg,
  'XCloseSmallBoldIcon',
  16
);
export const XCloseMediumIcon = createIcon(
  XCloseMediumIconSvg,
  'XCloseMediumIcon',
  20
);
export const XCloseMediumBoldIcon = createIcon(
  XCloseMediumBoldIconSvg,
  'XCloseMediumBoldIcon',
  20
);
export const XCloseLargeIcon = createIcon(
  XCloseLargeIconSvg,
  'XCloseLargeIcon',
  24
);
export const XCloseLargeBoldIcon = createIcon(
  XCloseLargeBoldIconSvg,
  'XCloseLargeBoldIcon',
  24
);
export const XXSmallIcon = createIcon(XXSmallIconSvg, 'XXSmallIcon', 12);
export const XXSmallBoldIcon = createIcon(
  XXSmallBoldIconSvg,
  'XXSmallBoldIcon',
  12
);
export const XSmallIcon = createIcon(XSmallIconSvg, 'XSmallIcon', 16);
export const XSmallBoldIcon = createIcon(
  XSmallBoldIconSvg,
  'XSmallBoldIcon',
  16
);
export const XMediumIcon = createIcon(XMediumIconSvg, 'XMediumIcon', 20);
export const XMediumBoldIcon = createIcon(
  XMediumBoldIconSvg,
  'XMediumBoldIcon',
  20
);
export const XLargeIcon = createIcon(XLargeIconSvg, 'XLargeIcon', 24);
export const XLargeBoldIcon = createIcon(
  XLargeBoldIconSvg,
  'XLargeBoldIcon',
  24
);
export const XCircleXSmallIcon = createIcon(
  XCircleXSmallIconSvg,
  'XCircleXSmallIcon',
  12
);
export const XCircleXSmallBoldIcon = createIcon(
  XCircleXSmallBoldIconSvg,
  'XCircleXSmallBoldIcon',
  12
);
export const XCircleSmallIcon = createIcon(
  XCircleSmallIconSvg,
  'XCircleSmallIcon',
  16
);
export const XCircleSmallBoldIcon = createIcon(
  XCircleSmallBoldIconSvg,
  'XCircleSmallBoldIcon',
  16
);
export const XCircleMediumIcon = createIcon(
  XCircleMediumIconSvg,
  'XCircleMediumIcon',
  20
);
export const XCircleMediumBoldIcon = createIcon(
  XCircleMediumBoldIconSvg,
  'XCircleMediumBoldIcon',
  20
);
export const XCircleLargeIcon = createIcon(
  XCircleLargeIconSvg,
  'XCircleLargeIcon',
  24
);
export const XCircleLargeBoldIcon = createIcon(
  XCircleLargeBoldIconSvg,
  'XCircleLargeBoldIcon',
  24
);
export const HelpCircleXSmallIcon = createIcon(
  HelpCircleXSmallIconSvg,
  'HelpCircleXSmallIcon',
  12
);
export const HelpCircleXSmallBoldIcon = createIcon(
  HelpCircleXSmallBoldIconSvg,
  'HelpCircleXSmallBoldIcon',
  12
);
export const HelpCircleSmallIcon = createIcon(
  HelpCircleSmallIconSvg,
  'HelpCircleSmallIcon',
  16
);
export const HelpCircleSmallBoldIcon = createIcon(
  HelpCircleSmallBoldIconSvg,
  'HelpCircleSmallBoldIcon',
  16
);
export const HelpCircleMediumIcon = createIcon(
  HelpCircleMediumIconSvg,
  'HelpCircleMediumIcon',
  20
);
export const HelpCircleMediumBoldIcon = createIcon(
  HelpCircleMediumBoldIconSvg,
  'HelpCircleMediumBoldIcon',
  20
);
export const HelpCircleLargeIcon = createIcon(
  HelpCircleLargeIconSvg,
  'HelpCircleLargeIcon',
  24
);
export const HelpCircleLargeBoldIcon = createIcon(
  HelpCircleLargeBoldIconSvg,
  'HelpCircleLargeBoldIcon',
  24
);
export const InfoCircleXSmallIcon = createIcon(
  InfoCircleXSmallIconSvg,
  'InfoCircleXSmallIcon',
  12
);
export const InfoCircleXSmallBoldIcon = createIcon(
  InfoCircleXSmallBoldIconSvg,
  'InfoCircleXSmallBoldIcon',
  12
);
export const InfoCircleSmallIcon = createIcon(
  InfoCircleSmallIconSvg,
  'InfoCircleSmallIcon',
  16
);
export const InfoCircleSmallBoldIcon = createIcon(
  InfoCircleSmallBoldIconSvg,
  'InfoCircleSmallBoldIcon',
  16
);
export const InfoCircleMediumIcon = createIcon(
  InfoCircleMediumIconSvg,
  'InfoCircleMediumIcon',
  20
);
export const InfoCircleMediumBoldIcon = createIcon(
  InfoCircleMediumBoldIconSvg,
  'InfoCircleMediumBoldIcon',
  20
);
export const InfoCircleLargeIcon = createIcon(
  InfoCircleLargeIconSvg,
  'InfoCircleLargeIcon',
  24
);
export const InfoCircleLargeBoldIcon = createIcon(
  InfoCircleLargeBoldIconSvg,
  'InfoCircleLargeBoldIcon',
  24
);
export const HeartRoundedXSmallIcon = createIcon(
  HeartRoundedXSmallIconSvg,
  'HeartRoundedXSmallIcon',
  12
);
export const HeartRoundedXSmallBoldIcon = createIcon(
  HeartRoundedXSmallBoldIconSvg,
  'HeartRoundedXSmallBoldIcon',
  12
);
export const HeartRoundedSmallIcon = createIcon(
  HeartRoundedSmallIconSvg,
  'HeartRoundedSmallIcon',
  16
);
export const HeartRoundedSmallBoldIcon = createIcon(
  HeartRoundedSmallBoldIconSvg,
  'HeartRoundedSmallBoldIcon',
  16
);
export const HeartRoundedMediumIcon = createIcon(
  HeartRoundedMediumIconSvg,
  'HeartRoundedMediumIcon',
  20
);
export const HeartRoundedMediumBoldIcon = createIcon(
  HeartRoundedMediumBoldIconSvg,
  'HeartRoundedMediumBoldIcon',
  20
);
export const HeartRoundedLargeIcon = createIcon(
  HeartRoundedLargeIconSvg,
  'HeartRoundedLargeIcon',
  24
);
export const HeartRoundedLargeBoldIcon = createIcon(
  HeartRoundedLargeBoldIconSvg,
  'HeartRoundedLargeBoldIcon',
  24
);
export const CurrencyDollarCircleXSmallIcon = createIcon(
  CurrencyDollarCircleXSmallIconSvg,
  'CurrencyDollarCircleXSmallIcon',
  12
);
export const CurrencyDollarCircleXSmallBoldIcon = createIcon(
  CurrencyDollarCircleXSmallBoldIconSvg,
  'CurrencyDollarCircleXSmallBoldIcon',
  12
);
export const CurrencyDollarCircleSmallIcon = createIcon(
  CurrencyDollarCircleSmallIconSvg,
  'CurrencyDollarCircleSmallIcon',
  16
);
export const CurrencyDollarCircleSmallBoldIcon = createIcon(
  CurrencyDollarCircleSmallBoldIconSvg,
  'CurrencyDollarCircleSmallBoldIcon',
  16
);
export const CurrencyDollarCircleMediumIcon = createIcon(
  CurrencyDollarCircleMediumIconSvg,
  'CurrencyDollarCircleMediumIcon',
  20
);
export const CurrencyDollarCircleMediumBoldIcon = createIcon(
  CurrencyDollarCircleMediumBoldIconSvg,
  'CurrencyDollarCircleMediumBoldIcon',
  20
);
export const CurrencyDollarCircleLargeIcon = createIcon(
  CurrencyDollarCircleLargeIconSvg,
  'CurrencyDollarCircleLargeIcon',
  24
);
export const CurrencyDollarCircleLargeBoldIcon = createIcon(
  CurrencyDollarCircleLargeBoldIconSvg,
  'CurrencyDollarCircleLargeBoldIcon',
  24
);
export const Lock01XSmallIcon = createIcon(
  Lock01XSmallIconSvg,
  'Lock01XSmallIcon',
  12
);
export const Lock01XSmallBoldIcon = createIcon(
  Lock01XSmallBoldIconSvg,
  'Lock01XSmallBoldIcon',
  12
);
export const Lock01SmallIcon = createIcon(
  Lock01SmallIconSvg,
  'Lock01SmallIcon',
  16
);
export const Lock01SmallBoldIcon = createIcon(
  Lock01SmallBoldIconSvg,
  'Lock01SmallBoldIcon',
  16
);
export const Lock01MediumIcon = createIcon(
  Lock01MediumIconSvg,
  'Lock01MediumIcon',
  20
);
export const Lock01MediumBoldIcon = createIcon(
  Lock01MediumBoldIconSvg,
  'Lock01MediumBoldIcon',
  20
);
export const Lock01LargeIcon = createIcon(
  Lock01LargeIconSvg,
  'Lock01LargeIcon',
  24
);
export const Lock01LargeBoldIcon = createIcon(
  Lock01LargeBoldIconSvg,
  'Lock01LargeBoldIcon',
  24
);
export const LockUnlocked01XSmallIcon = createIcon(
  LockUnlocked01XSmallIconSvg,
  'LockUnlocked01XSmallIcon',
  12
);
export const LockUnlocked01XSmallBoldIcon = createIcon(
  LockUnlocked01XSmallBoldIconSvg,
  'LockUnlocked01XSmallBoldIcon',
  12
);
export const LockUnlocked01SmallIcon = createIcon(
  LockUnlocked01SmallIconSvg,
  'LockUnlocked01SmallIcon',
  16
);
export const LockUnlocked01SmallBoldIcon = createIcon(
  LockUnlocked01SmallBoldIconSvg,
  'LockUnlocked01SmallBoldIcon',
  16
);
export const LockUnlocked01MediumIcon = createIcon(
  LockUnlocked01MediumIconSvg,
  'LockUnlocked01MediumIcon',
  20
);
export const LockUnlocked01MediumBoldIcon = createIcon(
  LockUnlocked01MediumBoldIconSvg,
  'LockUnlocked01MediumBoldIcon',
  20
);
export const LockUnlocked01LargeIcon = createIcon(
  LockUnlocked01LargeIconSvg,
  'LockUnlocked01LargeIcon',
  24
);
export const LockUnlocked01LargeBoldIcon = createIcon(
  LockUnlocked01LargeBoldIconSvg,
  'LockUnlocked01LargeBoldIcon',
  24
);
export const ClockXSmallIcon = createIcon(
  ClockXSmallIconSvg,
  'ClockXSmallIcon',
  12
);
export const ClockXSmallBoldIcon = createIcon(
  ClockXSmallBoldIconSvg,
  'ClockXSmallBoldIcon',
  12
);
export const ClockSmallIcon = createIcon(
  ClockSmallIconSvg,
  'ClockSmallIcon',
  16
);
export const ClockSmallBoldIcon = createIcon(
  ClockSmallBoldIconSvg,
  'ClockSmallBoldIcon',
  16
);
export const ClockMediumIcon = createIcon(
  ClockMediumIconSvg,
  'ClockMediumIcon',
  20
);
export const ClockMediumBoldIcon = createIcon(
  ClockMediumBoldIconSvg,
  'ClockMediumBoldIcon',
  20
);
export const ClockLargeIcon = createIcon(
  ClockLargeIconSvg,
  'ClockLargeIcon',
  24
);
export const ClockLargeBoldIcon = createIcon(
  ClockLargeBoldIconSvg,
  'ClockLargeBoldIcon',
  24
);
export const Recording02XSmallIcon = createIcon(
  Recording02XSmallIconSvg,
  'Recording02XSmallIcon',
  12
);
export const Recording02XSmallBoldIcon = createIcon(
  Recording02XSmallBoldIconSvg,
  'Recording02XSmallBoldIcon',
  12
);
export const Recording02SmallIcon = createIcon(
  Recording02SmallIconSvg,
  'Recording02SmallIcon',
  16
);
export const Recording02SmallBoldIcon = createIcon(
  Recording02SmallBoldIconSvg,
  'Recording02SmallBoldIcon',
  16
);
export const Recording02MediumIcon = createIcon(
  Recording02MediumIconSvg,
  'Recording02MediumIcon',
  20
);
export const Recording02MediumBoldIcon = createIcon(
  Recording02MediumBoldIconSvg,
  'Recording02MediumBoldIcon',
  20
);
export const Recording02LargeIcon = createIcon(
  Recording02LargeIconSvg,
  'Recording02LargeIcon',
  24
);
export const Recording02LargeBoldIcon = createIcon(
  Recording02LargeBoldIconSvg,
  'Recording02LargeBoldIcon',
  24
);
export const BrowserXSmallIcon = createIcon(
  BrowserXSmallIconSvg,
  'BrowserXSmallIcon',
  12
);
export const BrowserXSmallBoldIcon = createIcon(
  BrowserXSmallBoldIconSvg,
  'BrowserXSmallBoldIcon',
  12
);
export const BrowserSmallIcon = createIcon(
  BrowserSmallIconSvg,
  'BrowserSmallIcon',
  16
);
export const BrowserSmallBoldIcon = createIcon(
  BrowserSmallBoldIconSvg,
  'BrowserSmallBoldIcon',
  16
);
export const BrowserMediumIcon = createIcon(
  BrowserMediumIconSvg,
  'BrowserMediumIcon',
  20
);
export const BrowserMediumBoldIcon = createIcon(
  BrowserMediumBoldIconSvg,
  'BrowserMediumBoldIcon',
  20
);
export const BrowserLargeIcon = createIcon(
  BrowserLargeIconSvg,
  'BrowserLargeIcon',
  24
);
export const BrowserLargeBoldIcon = createIcon(
  BrowserLargeBoldIconSvg,
  'BrowserLargeBoldIcon',
  24
);
export const Mail01XSmallIcon = createIcon(
  Mail01XSmallIconSvg,
  'Mail01XSmallIcon',
  12
);
export const Mail01XSmallBoldIcon = createIcon(
  Mail01XSmallBoldIconSvg,
  'Mail01XSmallBoldIcon',
  12
);
export const Mail01SmallIcon = createIcon(
  Mail01SmallIconSvg,
  'Mail01SmallIcon',
  16
);
export const Mail01SmallBoldIcon = createIcon(
  Mail01SmallBoldIconSvg,
  'Mail01SmallBoldIcon',
  16
);
export const Mail01MediumIcon = createIcon(
  Mail01MediumIconSvg,
  'Mail01MediumIcon',
  20
);
export const Mail01MediumBoldIcon = createIcon(
  Mail01MediumBoldIconSvg,
  'Mail01MediumBoldIcon',
  20
);
export const Mail01LargeIcon = createIcon(
  Mail01LargeIconSvg,
  'Mail01LargeIcon',
  24
);
export const Mail01LargeBoldIcon = createIcon(
  Mail01LargeBoldIconSvg,
  'Mail01LargeBoldIcon',
  24
);
export const MarkerPin01XSmallIcon = createIcon(
  MarkerPin01XSmallIconSvg,
  'MarkerPin01XSmallIcon',
  12
);
export const MarkerPin01XSmallBoldIcon = createIcon(
  MarkerPin01XSmallBoldIconSvg,
  'MarkerPin01XSmallBoldIcon',
  12
);
export const MarkerPin01SmallIcon = createIcon(
  MarkerPin01SmallIconSvg,
  'MarkerPin01SmallIcon',
  16
);
export const MarkerPin01SmallBoldIcon = createIcon(
  MarkerPin01SmallBoldIconSvg,
  'MarkerPin01SmallBoldIcon',
  16
);
export const MarkerPin01MediumIcon = createIcon(
  MarkerPin01MediumIconSvg,
  'MarkerPin01MediumIcon',
  20
);
export const MarkerPin01MediumBoldIcon = createIcon(
  MarkerPin01MediumBoldIconSvg,
  'MarkerPin01MediumBoldIcon',
  20
);
export const MarkerPin01LargeIcon = createIcon(
  MarkerPin01LargeIconSvg,
  'MarkerPin01LargeIcon',
  24
);
export const MarkerPin01LargeBoldIcon = createIcon(
  MarkerPin01LargeBoldIconSvg,
  'MarkerPin01LargeBoldIcon',
  24
);
export const Settings03XSmallIcon = createIcon(
  Settings03XSmallIconSvg,
  'Settings03XSmallIcon',
  12
);
export const Settings03XSmallBoldIcon = createIcon(
  Settings03XSmallBoldIconSvg,
  'Settings03XSmallBoldIcon',
  12
);
export const Settings03SmallIcon = createIcon(
  Settings03SmallIconSvg,
  'Settings03SmallIcon',
  16
);
export const Settings03SmallBoldIcon = createIcon(
  Settings03SmallBoldIconSvg,
  'Settings03SmallBoldIcon',
  16
);
export const Settings03MediumIcon = createIcon(
  Settings03MediumIconSvg,
  'Settings03MediumIcon',
  20
);
export const Settings03MediumBoldIcon = createIcon(
  Settings03MediumBoldIconSvg,
  'Settings03MediumBoldIcon',
  20
);
export const Settings03LargeIcon = createIcon(
  Settings03LargeIconSvg,
  'Settings03LargeIcon',
  24
);
export const Settings03LargeBoldIcon = createIcon(
  Settings03LargeBoldIconSvg,
  'Settings03LargeBoldIcon',
  24
);
export const Settings04XSmallIcon = createIcon(
  Settings04XSmallIconSvg,
  'Settings04XSmallIcon',
  12
);
export const Settings04XSmallBoldIcon = createIcon(
  Settings04XSmallBoldIconSvg,
  'Settings04XSmallBoldIcon',
  12
);
export const Settings04SmallIcon = createIcon(
  Settings04SmallIconSvg,
  'Settings04SmallIcon',
  16
);
export const Settings04SmallBoldIcon = createIcon(
  Settings04SmallBoldIconSvg,
  'Settings04SmallBoldIcon',
  16
);
export const Settings04MediumIcon = createIcon(
  Settings04MediumIconSvg,
  'Settings04MediumIcon',
  20
);
export const Settings04MediumBoldIcon = createIcon(
  Settings04MediumBoldIconSvg,
  'Settings04MediumBoldIcon',
  20
);
export const Settings04LargeIcon = createIcon(
  Settings04LargeIconSvg,
  'Settings04LargeIcon',
  24
);
export const Settings04LargeBoldIcon = createIcon(
  Settings04LargeBoldIconSvg,
  'Settings04LargeBoldIcon',
  24
);
export const Code02XSmallIcon = createIcon(
  Code02XSmallIconSvg,
  'Code02XSmallIcon',
  12
);
export const Code02XSmallBoldIcon = createIcon(
  Code02XSmallBoldIconSvg,
  'Code02XSmallBoldIcon',
  12
);
export const Code02SmallIcon = createIcon(
  Code02SmallIconSvg,
  'Code02SmallIcon',
  16
);
export const Code02SmallBoldIcon = createIcon(
  Code02SmallBoldIconSvg,
  'Code02SmallBoldIcon',
  16
);
export const Code02MediumIcon = createIcon(
  Code02MediumIconSvg,
  'Code02MediumIcon',
  20
);
export const Code02MediumBoldIcon = createIcon(
  Code02MediumBoldIconSvg,
  'Code02MediumBoldIcon',
  20
);
export const Code02LargeIcon = createIcon(
  Code02LargeIconSvg,
  'Code02LargeIcon',
  24
);
export const Code02LargeBoldIcon = createIcon(
  Code02LargeBoldIconSvg,
  'Code02LargeBoldIcon',
  24
);
export const Bot01XSmallIcon = createIcon(
  Bot01XSmallIconSvg,
  'Bot01XSmallIcon',
  12
);
export const Bot01XSmallBoldIcon = createIcon(
  Bot01XSmallBoldIconSvg,
  'Bot01XSmallBoldIcon',
  12
);
export const Bot01SmallIcon = createIcon(
  Bot01SmallIconSvg,
  'Bot01SmallIcon',
  16
);
export const Bot01SmallBoldIcon = createIcon(
  Bot01SmallBoldIconSvg,
  'Bot01SmallBoldIcon',
  16
);
export const Bot01MediumIcon = createIcon(
  Bot01MediumIconSvg,
  'Bot01MediumIcon',
  20
);
export const Bot01MediumBoldIcon = createIcon(
  Bot01MediumBoldIconSvg,
  'Bot01MediumBoldIcon',
  20
);
export const Bot01LargeIcon = createIcon(
  Bot01LargeIconSvg,
  'Bot01LargeIcon',
  24
);
export const Bot01LargeBoldIcon = createIcon(
  Bot01LargeBoldIconSvg,
  'Bot01LargeBoldIcon',
  24
);
export const Rocket02XSmallIcon = createIcon(
  Rocket02XSmallIconSvg,
  'Rocket02XSmallIcon',
  12
);
export const Rocket02XSmallBoldIcon = createIcon(
  Rocket02XSmallBoldIconSvg,
  'Rocket02XSmallBoldIcon',
  12
);
export const Rocket02SmallIcon = createIcon(
  Rocket02SmallIconSvg,
  'Rocket02SmallIcon',
  16
);
export const Rocket02SmallBoldIcon = createIcon(
  Rocket02SmallBoldIconSvg,
  'Rocket02SmallBoldIcon',
  16
);
export const Rocket02MediumIcon = createIcon(
  Rocket02MediumIconSvg,
  'Rocket02MediumIcon',
  20
);
export const Rocket02MediumBoldIcon = createIcon(
  Rocket02MediumBoldIconSvg,
  'Rocket02MediumBoldIcon',
  20
);
export const Rocket02LargeIcon = createIcon(
  Rocket02LargeIconSvg,
  'Rocket02LargeIcon',
  24
);
export const Rocket02LargeBoldIcon = createIcon(
  Rocket02LargeBoldIconSvg,
  'Rocket02LargeBoldIcon',
  24
);
export const Copy03AiXSmallIcon = createIcon(
  Copy03AiXSmallIconSvg,
  'Copy03AiXSmallIcon',
  12
);
export const Copy03AiXSmallBoldIcon = createIcon(
  Copy03AiXSmallBoldIconSvg,
  'Copy03AiXSmallBoldIcon',
  12
);
export const Copy03AiSmallIcon = createIcon(
  Copy03AiSmallIconSvg,
  'Copy03AiSmallIcon',
  16
);
export const Copy03AiSmallBoldIcon = createIcon(
  Copy03AiSmallBoldIconSvg,
  'Copy03AiSmallBoldIcon',
  16
);
export const Copy03AiMediumIcon = createIcon(
  Copy03AiMediumIconSvg,
  'Copy03AiMediumIcon',
  20
);
export const Copy03AiMediumBoldIcon = createIcon(
  Copy03AiMediumBoldIconSvg,
  'Copy03AiMediumBoldIcon',
  20
);
export const Copy03AiLargeIcon = createIcon(
  Copy03AiLargeIconSvg,
  'Copy03AiLargeIcon',
  24
);
export const Copy03AiLargeBoldIcon = createIcon(
  Copy03AiLargeBoldIconSvg,
  'Copy03AiLargeBoldIcon',
  24
);
export const MappingXSmallIcon = createIcon(
  MappingXSmallIconSvg,
  'MappingXSmallIcon',
  12
);
export const MappingXSmallBoldIcon = createIcon(
  MappingXSmallBoldIconSvg,
  'MappingXSmallBoldIcon',
  12
);
export const MappingSmallIcon = createIcon(
  MappingSmallIconSvg,
  'MappingSmallIcon',
  16
);
export const MappingSmallBoldIcon = createIcon(
  MappingSmallBoldIconSvg,
  'MappingSmallBoldIcon',
  16
);
export const MappingMediumIcon = createIcon(
  MappingMediumIconSvg,
  'MappingMediumIcon',
  20
);
export const MappingMediumBoldIcon = createIcon(
  MappingMediumBoldIconSvg,
  'MappingMediumBoldIcon',
  20
);
export const MappingLargeIcon = createIcon(
  MappingLargeIconSvg,
  'MappingLargeIcon',
  24
);
export const MappingLargeBoldIcon = createIcon(
  MappingLargeBoldIconSvg,
  'MappingLargeBoldIcon',
  24
);
export const Tag01XSmallIcon = createIcon(
  Tag01XSmallIconSvg,
  'Tag01XSmallIcon',
  12
);
export const Tag01XSmallBoldIcon = createIcon(
  Tag01XSmallBoldIconSvg,
  'Tag01XSmallBoldIcon',
  12
);
export const Tag01SmallIcon = createIcon(
  Tag01SmallIconSvg,
  'Tag01SmallIcon',
  16
);
export const Tag01SmallBoldIcon = createIcon(
  Tag01SmallBoldIconSvg,
  'Tag01SmallBoldIcon',
  16
);
export const Tag01MediumIcon = createIcon(
  Tag01MediumIconSvg,
  'Tag01MediumIcon',
  20
);
export const Tag01MediumBoldIcon = createIcon(
  Tag01MediumBoldIconSvg,
  'Tag01MediumBoldIcon',
  20
);
export const Tag01LargeIcon = createIcon(
  Tag01LargeIconSvg,
  'Tag01LargeIcon',
  24
);
export const Tag01LargeBoldIcon = createIcon(
  Tag01LargeBoldIconSvg,
  'Tag01LargeBoldIcon',
  24
);
export const CreditCardCheckXSmallIcon = createIcon(
  CreditCardCheckXSmallIconSvg,
  'CreditCardCheckXSmallIcon',
  12
);
export const CreditCardCheckXSmallBoldIcon = createIcon(
  CreditCardCheckXSmallBoldIconSvg,
  'CreditCardCheckXSmallBoldIcon',
  12
);
export const CreditCardCheckSmallIcon = createIcon(
  CreditCardCheckSmallIconSvg,
  'CreditCardCheckSmallIcon',
  16
);
export const CreditCardCheckSmallBoldIcon = createIcon(
  CreditCardCheckSmallBoldIconSvg,
  'CreditCardCheckSmallBoldIcon',
  16
);
export const CreditCardCheckMediumIcon = createIcon(
  CreditCardCheckMediumIconSvg,
  'CreditCardCheckMediumIcon',
  20
);
export const CreditCardCheckMediumBoldIcon = createIcon(
  CreditCardCheckMediumBoldIconSvg,
  'CreditCardCheckMediumBoldIcon',
  20
);
export const CreditCardCheckLargeIcon = createIcon(
  CreditCardCheckLargeIconSvg,
  'CreditCardCheckLargeIcon',
  24
);
export const CreditCardCheckLargeBoldIcon = createIcon(
  CreditCardCheckLargeBoldIconSvg,
  'CreditCardCheckLargeBoldIcon',
  24
);
export const SwitchVertical01XSmallIcon = createIcon(
  SwitchVertical01XSmallIconSvg,
  'SwitchVertical01XSmallIcon',
  12
);
export const SwitchVertical01XSmallBoldIcon = createIcon(
  SwitchVertical01XSmallBoldIconSvg,
  'SwitchVertical01XSmallBoldIcon',
  12
);
export const SwitchVertical01SmallIcon = createIcon(
  SwitchVertical01SmallIconSvg,
  'SwitchVertical01SmallIcon',
  16
);
export const SwitchVertical01SmallBoldIcon = createIcon(
  SwitchVertical01SmallBoldIconSvg,
  'SwitchVertical01SmallBoldIcon',
  16
);
export const SwitchVertical01MediumIcon = createIcon(
  SwitchVertical01MediumIconSvg,
  'SwitchVertical01MediumIcon',
  20
);
export const SwitchVertical01MediumBoldIcon = createIcon(
  SwitchVertical01MediumBoldIconSvg,
  'SwitchVertical01MediumBoldIcon',
  20
);
export const SwitchVertical01LargeIcon = createIcon(
  SwitchVertical01LargeIconSvg,
  'SwitchVertical01LargeIcon',
  24
);
export const SwitchVertical01LargeBoldIcon = createIcon(
  SwitchVertical01LargeBoldIconSvg,
  'SwitchVertical01LargeBoldIcon',
  24
);
